// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-08-27T21:38:22.892Z
// Property: Crown Pointe Apartments (ID: 6767906449165602)
// Collections: 21 amenities, 2 floorplans (live), 121 photos, 68 POIs, 2 reviews, 1 virtual tours, 6 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162419",
  "multihub_property_id": "6767906449165602",
  "property_external_id": "rplzdd3",
  "property_zillow_url": null,
  "property_apartments_url": "https://www.apartments.com/crown-pointe-apartments-oklahoma-city-ok/rplzdd3/",
  "property_google_business_url": "https://www.google.com/maps/place/Crown+Pointe+Apartments/data=!4m2!3m1!1s0x0:0xa0e79eb9954cb03c?sa=X&ved=2ahUKEwjg0dur-LySAxX2mGoFHSJyC2IQ_BJ6BAgVEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "crown-pointe-apartments",
  "property_name": "Crown Pointe Apartments",
  "property_website_url": "https://www.caseusa.com/apartments/ok/oklahoma-city/crown-pointe/",
  "property_domain": null,
  "property_address": "12600 North MacArthur",
  "property_full_address": "12600 North MacArthur, Oklahoma City, OK, 73142",
  "property_address_1": "12600 North MacArthur",
  "property_address_2": null,
  "property_address_city": "Oklahoma City",
  "property_address_state": "OK",
  "property_address_zip_full": null,
  "property_address_zip": "73142",
  "property_address_country": "US",
  "property_address_county": "Oklahoma County",
  "property_neighborhood_address": "Val Verde",
  "property_address_latitude": "35.5989",
  "property_address_longitude": "-97.6202",
  "property_email": "crownpointe@caseusa.com",
  "property_phone": "(405) 643-8198",
  "property_call_tracking_phone": "833-411-1053",
  "property_company_name": "Case & Associates",
  "property_company_url": "https://www.caseusa.com/",
  "agency_contacts": null,
  "property_type": "Apartments",
  "property_short_description": "At Crown Pointe Apartments in Oklahoma City, find your perfect blend of comfort and convenience. Choose from spacious one or two-bedroom floor plans featuring modern amenities like a sparkling pool, fitness center, and stylish clubhouse. Embrace a vibrant lifestyle—schedule your tour today to see your future home! Prefer to explore on your own time? Self-guided tours are available.",
  "property_long_description": "Welcome to Crown Pointe Apartments, your ideal home in the heart of Oklahoma City! Offering a variety of thoughtfully designed floor plans, including spacious one and two-bedroom apartments, our community is tailor-made for comfort and convenience. Each apartment features modern amenities like air conditioning, high-speed internet access, and fully equipped kitchens with microwaves, dishwashers, and refrigerators, ensuring you have everything you need at your fingertips.\n\nAt Crown Pointe, you’ll enjoy an array of exceptional property amenities that elevate your living experience. Dive into relaxation at our sparkling swimming pool or break a sweat at our state-of-the-art fitness center. The clubhouse is perfect for social gatherings, while our sundeck offers a serene spot for sunbathing. With on-site maintenance and a dedicated property manager, we ensure that your needs are met promptly and efficiently. \n\nOur gated community also provides peace of mind, with additional features such as laundry facilities, storage space, and covered patio or balcony options for leisurely outdoor moments. Enjoy the charm of your new home with unique touches like vaulted ceilings and walk-in closets. Experience the convenience of nearby shopping, dining, and entertainment, all while enjoying the tranquility that comes with living at Crown Pointe.\n\nFind your new home today! Browse our availability or schedule a tour to visit our vibrant community in Oklahoma City. Discover the perfect blend of comfort, style, and convenience at Crown Pointe Apartments!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019cfb40-5b47-7420-ba4f-e0f360470bb7.webp",
  "property_featured_image_media": {
    "alt_text": "Crown Pointe apartment complex monument sign with brick pillar and landscaping.",
    "public_id": "019cfb40-5b47-7420-ba4f-e0f360470bb7",
    "storage_key": "property/6767906449165602/019cfb40-5b47-7420-ba4f-e0f360470bb7.webp",
    "width": 3072,
    "height": 2049
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "360",
  "property_year_built": "1999",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "97.22222222222221",
  "property_admin_fee": null,
  "property_application_fee": "75",
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "500",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Breed Restrictions Apply",
  "property_pet_policy_description": "No weight limit, though breed restrictions apply. Maximum of two pets per household. One-time non‑refundable pet fee: $500 per pet. Monthly pet rent: $30 per pet.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://crownpointeapartmentsoklahomacity.securecafe.com/onlineleasing/crown-pointe-apartments-2/floorplans.aspx",
  "property_resident_portal_url": "https://crownpointeapartmentsoklahomacity.securecafe.com/residentservices/crown-pointe-apartments-2/userlogin.aspx",
  "property_apply_now_url": "https://crownpointeapartmentsoklahomacity.securecafe.com/onlineleasing/crown-pointe-apartments-2/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019f1f97-dcc4-74df-8748-595de36ae70b.webp",
  "property_primary_logo_media": {
    "alt_text": "Crown Pointe Apartment Homes logo",
    "public_id": "019f1f97-dcc4-74df-8748-595de36ae70b",
    "storage_key": "property/6767906449165602/019f1f97-dcc4-74df-8748-595de36ae70b.webp",
    "width": 2401,
    "height": 907
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019cfb40-4804-750b-a448-bcd24c50984e.webp",
  "property_secondary_logo_media": {
    "alt_text": "Case & Associates logo",
    "public_id": "019cfb40-4804-750b-a448-bcd24c50984e",
    "storage_key": "property/6767906449165602/019cfb40-4804-750b-a448-bcd24c50984e.webp",
    "width": 325,
    "height": 325
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019f1f9c-1259-74a6-8a85-21efa321b53a.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Crownpointe logo",
    "public_id": "019f1f9c-1259-74a6-8a85-21efa321b53a",
    "storage_key": "property/6767906449165602/019f1f9c-1259-74a6-8a85-21efa321b53a.webp",
    "width": 1280,
    "height": 483
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019f1f9c-06c3-718c-ad4a-db0630790451.webp",
  "property_mono_black_logo_media": {
    "alt_text": "CrownPointe logo",
    "public_id": "019f1f9c-06c3-718c-ad4a-db0630790451",
    "storage_key": "property/6767906449165602/019f1f9c-06c3-718c-ad4a-db0630790451.webp",
    "width": 1280,
    "height": 483
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
  "property_company_logo_media": {
    "alt_text": "Case & Associates logo",
    "public_id": "019cfb35-ce4c-7138-92b0-dd454c056e38",
    "storage_key": "company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
    "width": 640,
    "height": 256
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#73705e",
  "property_secondary_color": "rgb(200,188,171)",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "800 - 1000",
  "property_sqft_min": "800",
  "property_sqft_max": "1000",
  "property_price_range": "929 - 1149",
  "property_price_min": "929",
  "property_price_max": "1149",
  "property_available_units": 10,
  "property_facebook_url": "https://www.facebook.com/CrownPointeApts/photos/d41d8cd9/1940365970076120/",
  "property_instagram_url": "https://www.instagram.com/crownpointeokc/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJK6rHCwADsocRPLBMlbme56A",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/liberty-pointe-oklahoma-city-6",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Crown Pointe Apartments",
  "property_home_romance_title": "Embrace Comfort and Connection in Your New Apartment Community",
  "property_home_amenities_blurb": "Welcome to Crown Pointe Apartments in vibrant Oklahoma City, where comfort meets convenience. Choose from our thoughtfully designed one- and two-bedroom floor plans, complete with luxurious amenities like a sparkling pool, fitness center, and on-site maintenance. Enjoy a beautiful lifestyle with easy access to major highways and top-rated schools!",
  "property_home_floorplans_blurb": "Welcome to Crown Pointe Apartments in vibrant Oklahoma City, where comfort meets style. Choose from our thoughtfully designed one and two-bedroom layouts tailored to fit your lifestyle. With a range of elegant options to suit your needs, it’s time to find the perfect floor plan for your next home.",
  "property_home_gallery_blurb": "At Crown Pointe Apartments in vibrant Oklahoma City, experience the perfect blend of comfort and convenience. Choose from spacious one or two-bedroom floor plans brimming with modern amenities like a fitness center, inviting sundeck, and stunning vaulted ceilings. Picture yourself living here, surrounded by beautifully landscaped grounds and easy access to major highways!",
  "property_home_neighborhood_blurb": "Nestled in the heart of Oklahoma City, Crown Pointe Apartments offers a variety of spacious one and two-bedroom floor plans tailored for your lifestyle. Experience vibrant local attractions and hidden gems in our welcoming neighborhood. Dive into nearby favorites and discover what makes our community truly special!",
  "property_home_reviews_blurb": "At Crown Pointe Apartments in Oklahoma City, peace of mind comes standard. Residents rave about our “excellent amenities” and prompt maintenance team, ensuring all your needs are swiftly met. Enjoy the blend of a quiet, safe location with easy access to shopping and dining. Join our thriving community today! ",
  "property_neighborhood_blurb": "At Crown Pointe Apartments in Oklahoma City, your new home is surrounded by excellent educational institutions, including Dennis Elementary and Putnam City North High School. With vibrant local amenities, families thrive here, making it the ideal setting for comfort and connectivity. Dive into the charm of your future neighborhood today!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Crown Pointe Apartments in Oklahoma City, comfort and convenience reign supreme. Choose from our thoughtfully designed one- and two-bedroom floor plans, unwind by the sparkling pool, or elevate your fitness routine in our well-equipped center. Enjoy features like walk-in closets, private balconies, and smoke-free living. Embrace your ideal lifestyle today!",
  "property_applynow_blurb": "Welcome to Crown Pointe Apartments in Oklahoma City, where comfort meets convenience. Choose from stylish one and two-bedroom layouts, and enjoy amenities like a refreshing pool, modern fitness center, and inviting clubhouse. With on-site management and maintenance, your ideal living space awaits. Lease online today and elevate your lifestyle!",
  "property_contactus_blurb": "At Crown Pointe Apartments in Oklahoma City, find your perfect fit with our thoughtfully designed one and two-bedroom floor plans. Each space is crafted for comfort and convenience. Have questions? Our leasing team is ready to assist you—reach out today and step closer to your ideal home!",
  "property_faqs_blurb": "At Crown Pointe Apartments in Oklahoma City, we offer thoughtfully designed one and two-bedroom floor plans to fit your lifestyle. Have questions? Our FAQs page is your go-to resource for insights about our vibrant community. Dive in and uncover everything you need to know to make Crown Pointe your home!",
  "property_floorplans_blurb": "Welcome to Crown Pointe Apartments in vibrant Oklahoma City, where comfort meets style. Choose from our one or two-bedroom floor plans, each thoughtfully designed to enhance your living experience. Browse our available apartment homes today and uncover the perfect layout that suits your unique lifestyle. Your new beginning awaits!",
  "property_gallery_blurb": "At Crown Pointe Apartments in Oklahoma City, choose from stylish one or two-bedroom layouts designed for modern living. Enjoy resort-style amenities, including a sparkling pool, fitness center, and welcoming clubhouse. Picture yourself basking on your private balcony, surrounded by comfort and convenience. Make your dream apartment a reality today!",
  "property_interactivemap_blurb": "Welcome to Crown Pointe Apartments in Oklahoma City, where luxury meets comfort. Choose from spacious one- and two-bedroom floor plans with vaulted ceilings and walk-in closets. Enjoy top-notch amenities like a shimmering pool, state-of-the-art fitness center, and inviting clubhouse. Use our interactive community map to find your perfect home today!",
  "property_pets_blurb": "At Crown Pointe Apartments in vibrant Oklahoma City, your furry friends are part of the family! With no weight limits and a cozy community feel, each residence welcomes up to two pets. Embrace the joys of pet ownership with our tailored amenities – because home is where the pets are!",
  "property_referafriend_blurb": "At Crown Pointe Apartments in vibrant Oklahoma City, we offer stylish one and two-bedroom floor plans tailored for modern living. Share the joy of our welcoming community with friends—great friends make great neighbors! Refer a friend today and embrace the exceptional lifestyle awaiting you both!",
  "property_residentaccess_blurb": "At Crown Pointe Apartments in Oklahoma City, your perfect living space awaits! Choose from spacious one and two-bedroom floor plans designed for comfort. Access our resident portal to effortlessly manage your home, from paying rent to scheduling maintenance—your convenience is just a click away! Join our vibrant community today.",
  "property_reviews_blurb": "At Crown Pointe Apartments in Oklahoma City, our residents rave about the peaceful environment and efficient maintenance team. One satisfied resident noted, \"The maintenance response was excellent,\" highlighting our commitment to timely service. Enjoy a quiet, comfortable lifestyle in a well-kept community. See what our residents have to say!",
  "property_created_at": "1753982383401",
  "property_scheduletour_blurb": "At Crown Pointe Apartments in vibrant Oklahoma City, find the perfect one or two-bedroom home designed for your lifestyle. With a range of modern floor plans, comfort is just a step away. Curious about life here? Check out resident testimonials and schedule your personalized tour today!",
  "property_thankyou_blurb": "Thank you for reaching out to Crown Pointe Apartments in vibrant Oklahoma City! With spacious one and two-bedroom floor plans tailored to your lifestyle, our community is designed for comfort and convenience. A team member will connect with you soon to help turn your apartment dreams into reality!",
  "property_virtualtours_blurb": "At Crown Pointe Apartments in Oklahoma City, your ideal living space awaits! Choose from exquisite one and two-bedroom floor plans designed for comfort and style. Take a virtual tour now to envision your new home and embrace a lifestyle filled with modern amenities and community charm!",
  "property_copyright": "2025 All Rights Reserved. Crown Pointe Apartments",
  "property_seo_title_home": "Crown Pointe Apartments | Apartments in Oklahoma City, Oklahoma",
  "property_seo_description_home": "Experience modern living at Crown Pointe Apartments in Oklahoma City! Enjoy luxurious amenities, spacious floor plans, and a vibrant community—your new home awaits!",
  "property_seo_title_floorplans": "Floor Plans | 1 - 2 Apartments in Oklahoma City, Oklahoma",
  "property_seo_description_floorplans": "Find your ideal space at Crown Pointe Apartments in Oklahoma City! Choose from stylish one or two-bedroom floor plans. Browse our options today!",
  "property_seo_title_amenities": "Amenities | Oklahoma City, Oklahoma Apartments for Rent",
  "property_seo_description_amenities": "Unwind at Crown Pointe Apartments in Oklahoma City! Enjoy stylish living with modern amenities, a sparkling pool, fitness center, and much more. Your ideal home awaits!",
  "property_seo_title_gallery": "Gallery | Apartments in Oklahoma City, Oklahoma",
  "property_seo_description_gallery": "\"Picture your new life at Crown Pointe Apartments in OKC! Spacious floor plans, resort-style amenities, and a vibrant community await you. Your perfect home is just a click away!\"",
  "property_seo_title_virtualtours": "Virtual Tours | Crown Pointe Apartments Apartments",
  "property_seo_description_virtualtours": "Experience Crown Pointe Apartments in Oklahoma City! Take a virtual tour of our stunning one and two-bedroom homes and envision your future today!",
  "property_seo_title_interactivemap": "Interactive Map | Crown Pointe Apartments Apartments",
  "property_seo_description_interactivemap": "Find your perfect fit at Crown Pointe Apartments in Oklahoma City! Enjoy stunning amenities, spacious layouts, and an interactive map to uncover your new home!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Oklahoma City, Oklahoma",
  "property_seo_description_neighborhood": "Uncover the charm of Oklahoma City surrounding Crown Pointe Apartments. From local favorites to hidden gems, find your perfect neighborhood vibe here!",
  "property_seo_title_contact": "Contact Us | Crown Pointe Apartments",
  "property_seo_description_contact": "Reach out to our friendly leasing team at Crown Pointe Apartments in Oklahoma City. Whether you're seeking a cozy one-bedroom or spacious two-bedroom, we’re here to help!",
  "property_seo_title_faqs": "FAQs | Apartments in Oklahoma City, Oklahoma",
  "property_seo_description_faqs": "Find your perfect home at Crown Pointe Apartments in Oklahoma City! From luxury amenities to inviting floor plans, our FAQs cover all you need to know.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Oklahoma City, Oklahoma",
  "property_seo_description_reviews": "Experience life at Crown Pointe Apartments in Oklahoma City! From spacious floor plans to top-notch amenities, see what makes our community truly special. ",
  "property_seo_title_applynow": "Apply Now | Apartments in Oklahoma City, Oklahoma",
  "property_seo_description_applynow": "Experience modern living at Crown Pointe Apartments in Oklahoma City. Choose from stylish one or two-bedroom floor plans, with top-notch amenities and online leasing!",
  "property_seo_title_residentaccess": "Resident Access | Crown Pointe Apartments",
  "property_seo_description_residentaccess": "Access Crown Pointe's resident portal to effortlessly pay rent, schedule maintenance, and manage your home in vibrant Oklahoma City. Log in now!",
  "property_seo_title_referafriend": "Refer A Friend | Crown Pointe Apartments",
  "property_seo_description_referafriend": "\"Refer a friend to Crown Pointe Apartments in OKC! Share the joy of upscale living—great friends make the best neighbors. Join our community today!\"",
  "property_seo_title_scheduletour": "Schedule a Tour | Crown Pointe Apartments",
  "property_seo_description_scheduletour": "Experience luxury and comfort at Crown Pointe Apartments in Oklahoma City. Schedule your tour today and envision your ideal home in our vibrant community!",
  "property_seo_title_privacy": "Privacy Policy | Crown Pointe Apartments",
  "property_seo_description_privacy": "Your privacy matters at Crown Pointe Apartments. Learn how we protect your information while you enjoy life in beautiful Oklahoma City. View our privacy policy.",
  "property_seo_title_accessibility": "Website Accessibility | Crown Pointe Apartments",
  "property_seo_description_accessibility": "Experience seamless living at Crown Pointe Apartments in Oklahoma City. Our commitment to accessibility ensures everyone feels at home. Join us in embracing inclusion!",
  "property_seo_title_sitemap": "Sitemap | Crown Pointe Apartments",
  "property_seo_description_sitemap": "Unlock the journey to your dream home at Crown Pointe Apartments in Oklahoma City. Navigate our sitemap and find your perfect fit today!",
  "property_seo_title_thankyou": "Thank You | Crown Pointe Apartments",
  "property_seo_description_thankyou": "Thank you for reaching out to Crown Pointe Apartments! Our team will connect with you soon to help you find your perfect home in Oklahoma City. Stay tuned!",
  "property_seo_title_pets": "Pet Policy | Apartments in Oklahoma City, OK",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1787865188563",
  "amenities": [
    {
      "id": "ec_a7deda6673dc85bfa4c08cd8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "source": "yardi",
      "external_id": "127396542",
      "title": "BBQ/Picnic Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_74df1b2073cda814563d5e6b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "source": "yardi",
      "external_id": "127396543",
      "title": "Carport",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_12d9259919f36ca055e29538",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "source": "yardi",
      "external_id": "127396546",
      "title": "Availability 24 Hours",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d10be0e5964f5c8a61f94629",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "source": "yardi",
      "external_id": "127396548",
      "title": "Controlled Access/Gated",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_436d067fa44667212214dab1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "source": "yardi",
      "external_id": "127396549",
      "title": "Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e65a1a4730a39bb80849b1b9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "source": "yardi",
      "external_id": "127396550",
      "title": "Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_104b1ed5097b4254ed9df47b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "source": "yardi",
      "external_id": "128042530",
      "title": "Preinstalled WiFi Modem Powered by Cox",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d8098f48430c9ba6ad44c952",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "source": "yardi",
      "external_id": "127396551",
      "title": "Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_18ddf352d30fabcab52e2157",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "source": "yardi",
      "external_id": "128017282",
      "title": "flex. Payment Options Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d2c913dc6926b5526f65b840",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "source": "yardi",
      "external_id": "127398021",
      "title": "Furnished",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_96dc6759cffacebbcb939ec4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "source": "yardi",
      "external_id": "127398022",
      "title": "Efficient Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_92e33d10a7d6e66e0b62848c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "source": "yardi",
      "external_id": "127398023",
      "title": "Extra Storage",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d2c186a678dcae00769070ea",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "source": "yardi",
      "external_id": "127398024",
      "title": "Ceiling Fan",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8a1ba1a8a41815a272937b8f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "source": "yardi",
      "external_id": "127398025",
      "title": "Cable Ready",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ca81170ca28551cf932d6061",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "source": "yardi",
      "external_id": "127398026",
      "title": "Microwave",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_77b7cfef19a91b92175c28ab",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "source": "yardi",
      "external_id": "127398027",
      "title": "Carpeting",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_35f0e5c2b607eab40a9877bf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "source": "yardi",
      "external_id": "127398028",
      "title": "Patio/Balcony",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_171b4a72631bda2fbdd75339",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "source": "yardi",
      "external_id": "127398029",
      "title": "Large Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4c91686af4ea7c36cd9d91e0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "source": "yardi",
      "external_id": "127398030",
      "title": "High Ceilings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_74d5d7fd95dc122bdc0a8a67",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "source": "yardi",
      "external_id": "127398031",
      "title": "Washer/Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bbd4315789d298aa3c4d42b5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "source": "yardi",
      "external_id": "127398032",
      "title": "Fireplace",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_ac2d7b47-296a-443a-a8f5-6c8c39da6012",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d2708-c503-7727-acf8-0d7575cae080.webp",
      "image_media": {
        "alt_text": "Crown Pointe apartment community entrance monument sign with brick pillar and landscaping.",
        "public_id": "019d2708-c503-7727-acf8-0d7575cae080",
        "storage_key": "property/6767906449165602/019d2708-c503-7727-acf8-0d7575cae080.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Welcome to Crown Pointe, a premier apartment community. Our entrance features a prominent monument sign set amidst lush landscaping and elegant brickwork.",
      "link": "",
      "alt_text": "Crown Pointe apartment community entrance monument sign with brick pillar and landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019cfb3e-bf86-7078-84cd-2de571d85928.webp"
    },
    {
      "id": "custom_35029a05-18fe-44c9-aba5-8504c585a556",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d2708-c4d2-71b1-9949-421dc5d0ca88.webp",
      "image_media": {
        "alt_text": "Winding walkway leading past apartment buildings with balconies and manicured lawns.",
        "public_id": "019d2708-c4d2-71b1-9949-421dc5d0ca88",
        "storage_key": "property/6767906449165602/019d2708-c4d2-71b1-9949-421dc5d0ca88.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Enjoy the beautifully landscaped grounds and convenient walkways at our community. Ample green space and well-maintained buildings create a welcoming atmosphere.",
      "link": "",
      "alt_text": "Winding walkway leading past apartment buildings with balconies and manicured lawns.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019cfb3e-d596-77bd-be4e-c620fce57a4d.webp"
    },
    {
      "id": "custom_5b4ca92e-d537-4b06-ab19-5f10f871d900",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d2708-c51f-7488-acc0-8b806967a14d.webp",
      "image_media": {
        "alt_text": "Front entrance of apartment building with parking lot and cars.",
        "public_id": "019d2708-c51f-7488-acc0-8b806967a14d",
        "storage_key": "property/6767906449165602/019d2708-c51f-7488-acc0-8b806967a14d.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Welcome to the community's main building, featuring a well-maintained entrance and ample parking for residents and guests.",
      "link": "",
      "alt_text": "Front entrance of apartment building with parking lot and cars.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019cfb3e-d3e9-73eb-b0e1-c7a649dc386d.webp"
    },
    {
      "id": "custom_082e3614-3b23-447f-9338-69c6d5301765",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d2708-c52b-717c-bcee-6cac7f7abfe5.webp",
      "image_media": {
        "alt_text": "Outdoor seating area with a built-in grill and stone fireplace.",
        "public_id": "019d2708-c52b-717c-bcee-6cac7f7abfe5",
        "storage_key": "property/6767906449165602/019d2708-c52b-717c-bcee-6cac7f7abfe5.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Enjoy outdoor living with our community's spacious patio, featuring a grilling station and a cozy fireplace, perfect for gatherings.",
      "link": "",
      "alt_text": "Outdoor seating area with a built-in grill and stone fireplace.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165602/019cfb3f-3cb5-7179-8b06-a3914e78cb57.webp"
    },
    {
      "id": "custom_20c6466c-2536-4c6b-ba24-be977a1aa952",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d2708-d0df-72fa-a8df-28da69cda63a.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and apartment buildings in the background.",
        "public_id": "019d2708-d0df-72fa-a8df-28da69cda63a",
        "storage_key": "property/6767906449165602/019d2708-d0df-72fa-a8df-28da69cda63a.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by comfortable lounge chairs and lush landscaping. The perfect place to relax and unwind.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165602/019cfb3f-3c85-728d-92b6-0c4b3bf8c3cc.webp"
    },
    {
      "id": "custom_5296c56a-a2a2-42f7-8d2c-749cf100c2b2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d2708-d2d2-708b-8751-2c4695d6cd91.webp",
      "image_media": {
        "alt_text": "Outdoor grilling station with a built-in grill, stone fireplace, and seating area under a blue umbrella.",
        "public_id": "019d2708-d2d2-708b-8751-2c4695d6cd91",
        "storage_key": "property/6767906449165602/019d2708-d2d2-708b-8751-2c4695d6cd91.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Enjoy outdoor living with our community's grilling station, featuring a stainless steel grill, stone fireplace, and comfortable seating. Perfect for gatherings and al fresco dining.",
      "link": "",
      "alt_text": "Outdoor grilling station with a built-in grill, stone fireplace, and seating area under a blue umbrella.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019cfb3e-a9c1-7614-a0fc-84e8669ea5af.webp"
    },
    {
      "id": "custom_3b67a889-ceae-4562-b155-09a1549a9de1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d2708-d365-7027-b46f-a5f9ef7bb7cb.webp",
      "image_media": {
        "alt_text": "Spacious resident lounge with fireplace, seating area, and workstations.",
        "public_id": "019d2708-d365-7027-b46f-a5f9ef7bb7cb",
        "storage_key": "property/6767906449165602/019d2708-d365-7027-b46f-a5f9ef7bb7cb.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Relax and unwind in our resident lounge, featuring a cozy fireplace, comfortable seating, and convenient workstations for your productivity needs.",
      "link": "",
      "alt_text": "Spacious resident lounge with fireplace, seating area, and workstations.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019cfb3e-ac82-7528-a433-37485366c472.webp"
    },
    {
      "id": "custom_b0c7fbf5-2563-42b1-b826-a61824cab8bf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d2708-d388-715d-9dca-e79249fc7f6d.webp",
      "image_media": {
        "alt_text": "Luxurious communal lounge area with fireplace, large screen TV, comfortable seating, and a chandelier.",
        "public_id": "019d2708-d388-715d-9dca-e79249fc7f6d",
        "storage_key": "property/6767906449165602/019d2708-d388-715d-9dca-e79249fc7f6d.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Relax and unwind in our beautifully appointed communal lounge. Featuring a large fireplace, entertainment system, and ample seating, it's the perfect space to socialize or enjoy a quiet moment.",
      "link": "",
      "alt_text": "Luxurious communal lounge area with fireplace, large screen TV, comfortable seating, and a chandelier.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019cfb3e-bc30-777d-8633-eb8d966f7231.webp"
    },
    {
      "id": "custom_fa3f86ef-ab4c-44c8-a177-55273e91b5c4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d2708-db67-7536-85f0-576fdf9865f7.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, elliptical machines, and free weights.",
        "public_id": "019d2708-db67-7536-85f0-576fdf9865f7",
        "storage_key": "property/6767906449165602/019d2708-db67-7536-85f0-576fdf9865f7.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Stay active in our fully equipped fitness center, featuring cardio machines and free weights for a complete workout.",
      "link": "",
      "alt_text": "Fitness center with treadmills, elliptical machines, and free weights.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165602/019cfb3f-3476-7506-b5b3-9911fba814bc.webp"
    },
    {
      "id": "custom_7f8629b4-33f9-4ec3-8425-c6ec3c5fd57f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d2708-ddc3-7453-b077-cd6b757c8140.webp",
      "image_media": {
        "alt_text": "Living room with brown leather sofa, coffee tables, and a mounted TV.",
        "public_id": "019d2708-ddc3-7453-b077-cd6b757c8140",
        "storage_key": "property/6767906449165602/019d2708-ddc3-7453-b077-cd6b757c8140.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Apartment",
      "description": "Relax in this inviting living room featuring comfortable seating, a mounted television, and ample natural light from large windows.",
      "link": "",
      "alt_text": "Living room with brown leather sofa, coffee tables, and a mounted TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165602/019cfb3f-3f38-77c8-979d-6417d1de0a55.webp"
    },
    {
      "id": "custom_e63205a6-f707-4287-bb8a-70c33dc5d214",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d2708-de6a-7600-b399-161b8aa1f761.webp",
      "image_media": {
        "alt_text": "Living room with a fireplace, sofa, and coffee table.",
        "public_id": "019d2708-de6a-7600-b399-161b8aa1f761",
        "storage_key": "property/6767906449165602/019d2708-de6a-7600-b399-161b8aa1f761.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Cozy living room featuring a gas fireplace with stone surround, a comfortable sofa, and a coffee table, perfect for relaxing.",
      "link": "",
      "alt_text": "Living room with a fireplace, sofa, and coffee table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019cfb3e-aa2d-7268-abc1-6943ef662366.webp"
    },
    {
      "id": "custom_3f8c5324-fbe4-4308-8efa-2143b3467484",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d2708-e42b-77ef-874a-b570466b57d1.webp",
      "image_media": {
        "alt_text": "Living room with a fireplace and a view into the bedroom.",
        "public_id": "019d2708-e42b-77ef-874a-b570466b57d1",
        "storage_key": "property/6767906449165602/019d2708-e42b-77ef-874a-b570466b57d1.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Spacious living area with a cozy fireplace, seamlessly connected to a comfortable bedroom. Perfect for relaxation and entertaining.",
      "link": "",
      "alt_text": "Living room with a fireplace and a view into the bedroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019cfb3e-ace5-720e-9b5b-22d6e0098abb.webp"
    },
    {
      "id": "custom_6b495717-5b9f-4b61-8ede-e56bceec542a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d2708-e624-70ac-afe3-246c7f752c03.webp",
      "image_media": {
        "alt_text": "Kitchen with white appliances, wood cabinets, and laminate flooring.",
        "public_id": "019d2708-e624-70ac-afe3-246c7f752c03",
        "storage_key": "property/6767906449165602/019d2708-e624-70ac-afe3-246c7f752c03.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "A bright and functional kitchen featuring white appliances, ample cabinet space, and modern laminate flooring, perfect for everyday cooking and entertaining.",
      "link": "",
      "alt_text": "Kitchen with white appliances, wood cabinets, and laminate flooring.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019cfb3e-a901-72b9-a932-8d1bc808b3cd.webp"
    },
    {
      "id": "custom_c8a1ffa5-ff8f-4501-91d5-146e1098847e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d2708-e9a8-717e-a145-c6ba398e1b2b.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, nightstand, and window.",
        "public_id": "019d2708-e9a8-717e-a145-c6ba398e1b2b",
        "storage_key": "property/6767906449165602/019d2708-e9a8-717e-a145-c6ba398e1b2b.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Comfortable and stylish bedroom featuring a queen-size bed with plush bedding, a dark wood nightstand with a modern lamp, and large windows with blinds.",
      "link": "",
      "alt_text": "Bedroom with a queen-size bed, nightstand, and window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019cfb3e-a9ad-7193-9b37-71e023f54667.webp"
    },
    {
      "id": "custom_0d36ebbc-731c-485a-9363-8ed0fd798fe2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d2708-ea06-7483-a1a2-e2b7c4d25c3f.webp",
      "image_media": {
        "alt_text": "Living room with a television, coffee table, and entryway.",
        "public_id": "019d2708-ea06-7483-a1a2-e2b7c4d25c3f",
        "storage_key": "property/6767906449165602/019d2708-ea06-7483-a1a2-e2b7c4d25c3f.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Spacious living area with a television, decorative coffee table, and an entryway leading to the apartment.",
      "link": "",
      "alt_text": "Living room with a television, coffee table, and entryway.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019cfb3e-a92c-779e-bd34-977d74d99e8a.webp"
    },
    {
      "id": "custom_11618a1c-3417-4690-9db1-3f843e0f48cf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d2708-ed40-73a5-91ad-5dcb8d73275e.webp",
      "image_media": {
        "alt_text": "Kitchen with white refrigerator, wooden cabinets, and white oven.",
        "public_id": "019d2708-ed40-73a5-91ad-5dcb8d73275e",
        "storage_key": "property/6767906449165602/019d2708-ed40-73a5-91ad-5dcb8d73275e.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Bright and functional kitchen featuring modern appliances and ample cabinet storage.",
      "link": "",
      "alt_text": "Kitchen with white refrigerator, wooden cabinets, and white oven.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019cfb3e-b18c-715c-8934-27e6b4e9f8eb.webp"
    },
    {
      "id": "custom_dc0f4f0c-6ef5-4351-b0a9-2700c9c2a017",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d2708-f240-706f-9234-537a5cdab028.webp",
      "image_media": {
        "alt_text": "Bathroom with a white tub, shower with a striped curtain, and a toilet.",
        "public_id": "019d2708-f240-706f-9234-537a5cdab028",
        "storage_key": "property/6767906449165602/019d2708-f240-706f-9234-537a5cdab028.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Bright and clean bathroom featuring a white bathtub with a shower, a striped shower curtain, and a toilet with towels hanging nearby.",
      "link": "",
      "alt_text": "Bathroom with a white tub, shower with a striped curtain, and a toilet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019cfb3e-a8de-714c-bbf5-7bb8648a8e2f.webp"
    },
    {
      "id": "custom_72c1ff15-418a-4522-8d89-eec6dc89266c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d2708-f305-777e-b653-6275155a6027.webp",
      "image_media": {
        "alt_text": "Dining room with a wooden table and chairs, artwork on the wall, and a door leading outside.",
        "public_id": "019d2708-f305-777e-b653-6275155a6027",
        "storage_key": "property/6767906449165602/019d2708-f305-777e-b653-6275155a6027.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "A charming dining room featuring a rustic wooden table set for four, complemented by green upholstered chairs. The space is enhanced by a decorative landscape painting and a door with blinds offering a glimpse of the outdoors.",
      "link": "",
      "alt_text": "Dining room with a wooden table and chairs, artwork on the wall, and a door leading outside.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019cfb3e-b9fa-7336-bdd8-d24f86ab5f1e.webp"
    },
    {
      "id": "custom_aff7d809-8800-4529-9eed-ab71798d931c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d2708-f307-74ff-bf8e-afec89a96377.webp",
      "image_media": {
        "alt_text": "Living room with fireplace, sofa, coffee table, and dining area in background.",
        "public_id": "019d2708-f307-74ff-bf8e-afec89a96377",
        "storage_key": "property/6767906449165602/019d2708-f307-74ff-bf8e-afec89a96377.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Cozy living room featuring a fireplace, comfortable sofa, and a coffee table, with a dining area visible in the background. Perfect for relaxing or entertaining.",
      "link": "",
      "alt_text": "Living room with fireplace, sofa, coffee table, and dining area in background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019cfb3e-bd6d-714a-8b8b-5c181e91441e.webp"
    },
    {
      "id": "custom_b386e9ff-0cbb-444b-b575-537a37bbbdf8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d2708-f547-71d9-b4bb-faa9fdc412a0.webp",
      "image_media": {
        "alt_text": "Bathroom with toilet, vanity, and shower/tub combination.",
        "public_id": "019d2708-f547-71d9-b4bb-faa9fdc412a0",
        "storage_key": "property/6767906449165602/019d2708-f547-71d9-b4bb-faa9fdc412a0.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Spacious bathroom featuring a toilet, vanity, and a clean shower/tub combination. The decor adds a touch of style.",
      "link": "",
      "alt_text": "Bathroom with toilet, vanity, and shower/tub combination.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019cfb3e-bd90-76af-a179-741cca9a2c88.webp"
    },
    {
      "id": "custom_59045213-3dc4-4674-a77f-3b8f15d76069",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d2708-fad6-728e-a2db-72804610b1fc.webp",
      "image_media": {
        "alt_text": "Dining area with a high-top table and chairs, decorative mirror, and door to the outside.",
        "public_id": "019d2708-fad6-728e-a2db-72804610b1fc",
        "storage_key": "property/6767906449165602/019d2708-fad6-728e-a2db-72804610b1fc.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Stylish dining area featuring a bar-height table, comfortable seating, and a decorative mirror. Perfect for casual meals or entertaining.",
      "link": "",
      "alt_text": "Dining area with a high-top table and chairs, decorative mirror, and door to the outside.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019cfb3e-c07c-753e-9877-e5a30956a603.webp"
    },
    {
      "id": "custom_7533e04a-ec39-490c-b752-bab432d2e0f7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d2708-fb93-7319-ac57-0034ea0d2bc4.webp",
      "image_media": {
        "alt_text": "Living room with brown leather sofa, coffee tables, and large windows.",
        "public_id": "019d2708-fb93-7319-ac57-0034ea0d2bc4",
        "storage_key": "property/6767906449165602/019d2708-fb93-7319-ac57-0034ea0d2bc4.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a comfortable brown leather sofa, two dark wood coffee tables, and large windows dressed with white blinds and sheer curtains.",
      "link": "",
      "alt_text": "Living room with brown leather sofa, coffee tables, and large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019cfb3e-c3de-732e-9f82-78829f1be9f6.webp"
    },
    {
      "id": "custom_85ac14b8-e7d1-4962-a850-160ce8640200",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d2708-fb9e-731e-b972-341a9f78a8cd.webp",
      "image_media": {
        "alt_text": "Bright and clean bathroom with a white tub and shower, toilet, and vanity with a wood-grain countertop.",
        "public_id": "019d2708-fb9e-731e-b972-341a9f78a8cd",
        "storage_key": "property/6767906449165602/019d2708-fb9e-731e-b972-341a9f78a8cd.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Enjoy the spacious and well-appointed bathroom, featuring a bathtub/shower combination, modern vanity, and ample storage.",
      "link": "",
      "alt_text": "Bright and clean bathroom with a white tub and shower, toilet, and vanity with a wood-grain countertop.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019cfb3e-cbb3-73dc-a340-5a2839be2cb0.webp"
    },
    {
      "id": "custom_7815c817-463a-4beb-884e-ceb1a0d21cf6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d2708-fe8a-73da-8eaf-c4ea1cfe935f.webp",
      "image_media": {
        "alt_text": "Kitchen with light wood cabinets, white appliances, and granite countertops.",
        "public_id": "019d2708-fe8a-73da-8eaf-c4ea1cfe935f",
        "storage_key": "property/6767906449165602/019d2708-fe8a-73da-8eaf-c4ea1cfe935f.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Bright and functional kitchen featuring light wood cabinetry, a full suite of white appliances including a microwave and stove, and elegant granite countertops.",
      "link": "",
      "alt_text": "Kitchen with light wood cabinets, white appliances, and granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019cfb3e-d19f-768b-a2c3-a73b4d288e03.webp"
    },
    {
      "id": "custom_89dcd94f-0fcd-4052-abea-0cb787edde4b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d2709-02d4-742e-aa2f-52b571128f5f.webp",
      "image_media": {
        "alt_text": "Bathroom with toilet, vanity, and bathtub",
        "public_id": "019d2709-02d4-742e-aa2f-52b571128f5f",
        "storage_key": "property/6767906449165602/019d2709-02d4-742e-aa2f-52b571128f5f.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "A clean and functional bathroom featuring a vanity with ample counter space, a toilet, and a bathtub with a shower.",
      "link": "",
      "alt_text": "Bathroom with toilet, vanity, and bathtub",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019cfb3e-d739-74e1-8d56-a94ce98a28c6.webp"
    },
    {
      "id": "custom_3a2ca670-6420-40b7-bc0b-5f5eb54060de",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d2709-0351-73a2-b3a1-c33b2c614f5f.webp",
      "image_media": {
        "alt_text": "Queen-size bed with wrought iron frame, white comforter, and decorative pillows in a bedroom.",
        "public_id": "019d2709-0351-73a2-b3a1-c33b2c614f5f",
        "storage_key": "property/6767906449165602/019d2709-0351-73a2-b3a1-c33b2c614f5f.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a queen-size bed with a decorative wrought iron frame, cozy white linens, and matching nightstands and dresser for ample storage.",
      "link": "",
      "alt_text": "Queen-size bed with wrought iron frame, white comforter, and decorative pillows in a bedroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019cfb3e-d962-73bb-b79e-8a0eeee77447.webp"
    },
    {
      "id": "custom_cafeace3-e17b-4e5e-a2ec-045dff5e1cb4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d2709-04ae-730d-bb62-a1cd987290b6.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with sink and storage",
        "public_id": "019d2709-04ae-730d-bb62-a1cd987290b6",
        "storage_key": "property/6767906449165602/019d2709-04ae-730d-bb62-a1cd987290b6.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "A bright and clean bathroom featuring a modern vanity with a white sink, marble-look countertop, and ample storage. Includes a laundry area with shelving and storage baskets.",
      "link": "",
      "alt_text": "Bathroom vanity with sink and storage",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019cfb3e-da07-7649-a219-de4e516852c4.webp"
    },
    {
      "id": "custom_0ebbe854-e9f4-40ea-be2a-e181a3c8a7c2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d2709-0700-75d3-a3ce-8634fdd0d9c9.webp",
      "image_media": {
        "alt_text": "A bedroom with a queen-size bed, dark grey duvet, and decorative pillows. A painting of a cityscape hangs on the wall.",
        "public_id": "019d2709-0700-75d3-a3ce-8634fdd0d9c9",
        "storage_key": "property/6767906449165602/019d2709-0700-75d3-a3ce-8634fdd0d9c9.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Discover comfort in this beautifully appointed bedroom, featuring a plush queen-size bed and elegant decor. The vibrant cityscape art adds a touch of urban sophistication.",
      "link": "",
      "alt_text": "A bedroom with a queen-size bed, dark grey duvet, and decorative pillows. A painting of a cityscape hangs on the wall.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019cfb3e-f4cd-73b0-adb7-38efc4c5e2fb.webp"
    },
    {
      "id": "custom_5d2717c1-02a1-470d-a446-2f7933435217",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d2709-0c3b-759b-aad2-fd686ce3f650.webp",
      "image_media": {
        "alt_text": "Bathroom with toilet, sink, vanity, and shower curtain.",
        "public_id": "019d2709-0c3b-759b-aad2-fd686ce3f650",
        "storage_key": "property/6767906449165602/019d2709-0c3b-759b-aad2-fd686ce3f650.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "A clean and functional bathroom featuring a toilet, a sink with a granite countertop, wooden cabinetry, and a shower curtain.",
      "link": "",
      "alt_text": "Bathroom with toilet, sink, vanity, and shower curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019cfb3e-e2ea-72f9-b43a-50e3032b0ff8.webp"
    },
    {
      "id": "custom_a4f01320-1bfe-4524-b0f3-05fd36546ae6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d2709-0f4c-7105-ae8a-6e9c46ae466f.webp",
      "image_media": {
        "alt_text": "Living room with a leather sofa and a kitchen view with bar stools.",
        "public_id": "019d2709-0f4c-7105-ae8a-6e9c46ae466f",
        "storage_key": "property/6767906449165602/019d2709-0f4c-7105-ae8a-6e9c46ae466f.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Enjoy this open-concept living space, featuring a comfortable leather sofa and a pass-through to the kitchen, perfect for entertaining guests.",
      "link": "",
      "alt_text": "Living room with a leather sofa and a kitchen view with bar stools.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019cfb3e-e3cb-710a-910e-a2d25b2cdbd0.webp"
    },
    {
      "id": "custom_e88148da-8ca7-4f46-9ec8-ee0532561b11",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/01a03ed0-a459-779a-9e38-750aab9ab071.webp",
      "image_media": {
        "alt_text": "Dog park with agility equipment including a tunnel, ramp, and jumping platforms.",
        "public_id": "01a03ed0-a459-779a-9e38-750aab9ab071",
        "storage_key": "property/6767906449165602/01a03ed0-a459-779a-9e38-750aab9ab071.webp",
        "width": 3072,
        "height": 2458
      },
      "title": "Community",
      "description": "Our community dog park provides a fun and safe space for your furry friends to play and exercise with various agility features.",
      "link": "",
      "alt_text": "Dog park with agility equipment including a tunnel, ramp, and jumping platforms.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a099347a-890a-464c-8f8e-24734bb9fae0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/01a03ed0-9ebf-77ae-9682-127ab3a75719.webp",
      "image_media": {
        "alt_text": "Dog park with agility equipment including a ramp and a red dog-shaped obstacle.",
        "public_id": "01a03ed0-9ebf-77ae-9682-127ab3a75719",
        "storage_key": "property/6767906449165602/01a03ed0-9ebf-77ae-9682-127ab3a75719.webp",
        "width": 3072,
        "height": 2458
      },
      "title": "Community",
      "description": "Enjoy our dedicated dog park, featuring agility equipment for your furry friends to play and train.",
      "link": "",
      "alt_text": "Dog park with agility equipment including a ramp and a red dog-shaped obstacle.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5fa9a18f-85a2-4d6a-ad94-6d0796eef147",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/01a03ed0-963a-7558-8ea8-45fc204e26ae.webp",
      "image_media": {
        "alt_text": "Dog park with agility equipment like a tunnel, ramp, and stepping stones.",
        "public_id": "01a03ed0-963a-7558-8ea8-45fc204e26ae",
        "storage_key": "property/6767906449165602/01a03ed0-963a-7558-8ea8-45fc204e26ae.webp",
        "width": 3072,
        "height": 2458
      },
      "title": "Community",
      "description": "Enjoy our community dog park, complete with an agility course for your furry friends to play and exercise.",
      "link": "",
      "alt_text": "Dog park with agility equipment like a tunnel, ramp, and stepping stones.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ff7b04f2-a7e1-4394-b86f-c933d319de40",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/01a03ed0-9c65-728d-82f0-4f746f02f867.webp",
      "image_media": {
        "alt_text": "A dog park with agility equipment including an A-frame ramp and a dog-shaped agility obstacle.",
        "public_id": "01a03ed0-9c65-728d-82f0-4f746f02f867",
        "storage_key": "property/6767906449165602/01a03ed0-9c65-728d-82f0-4f746f02f867.webp",
        "width": 3072,
        "height": 2458
      },
      "title": "Community",
      "description": "Enjoy our on-site dog park, complete with agility equipment for your furry friends to play and train on.",
      "link": "",
      "alt_text": "A dog park with agility equipment including an A-frame ramp and a dog-shaped agility obstacle.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0808e227-4a49-4e66-b131-1ad4e61526b3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/01a03ed0-930c-74da-b717-19a818a9d1df.webp",
      "image_media": {
        "alt_text": "Welcome to Barking Timbers Pet Friendly Park with dog agility equipment.",
        "public_id": "01a03ed0-930c-74da-b717-19a818a9d1df",
        "storage_key": "property/6767906449165602/01a03ed0-930c-74da-b717-19a818a9d1df.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to Barking Timbers Pet Friendly Park, featuring agility equipment for your furry friends.",
      "link": "",
      "alt_text": "Welcome to Barking Timbers Pet Friendly Park with dog agility equipment.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_321383d6-2ac8-4bec-a03a-2589f1cfa7de",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/01a03ed0-920a-7589-aabd-66fd614fd421.webp",
      "image_media": {
        "alt_text": "Welcome to Barking Timbers Pet Friendly Park sign and agility equipment",
        "public_id": "01a03ed0-920a-7589-aabd-66fd614fd421",
        "storage_key": "property/6767906449165602/01a03ed0-920a-7589-aabd-66fd614fd421.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Explore the dedicated pet-friendly park at Barking Timbers, complete with agility equipment for your furry companions.",
      "link": "",
      "alt_text": "Welcome to Barking Timbers Pet Friendly Park sign and agility equipment",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_fd1a501e-20e4-402c-9019-ad2cc51a7660",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/01a03ed0-8698-76c4-ab19-a4c88e058ff9.webp",
      "image_media": {
        "alt_text": "Barking Timbers Pet Friendly Park with agility equipment and seating.",
        "public_id": "01a03ed0-8698-76c4-ab19-a4c88e058ff9",
        "storage_key": "property/6767906449165602/01a03ed0-8698-76c4-ab19-a4c88e058ff9.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to Barking Timbers Pet Friendly Park, featuring agility obstacles, play structures, and ample green space for your furry friends to enjoy.",
      "link": "",
      "alt_text": "Barking Timbers Pet Friendly Park with agility equipment and seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_00097fe9-ff00-4475-8b7c-264e3bc4388b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/01a03ed0-7bf5-74b9-931b-2546e890fc03.webp",
      "image_media": {
        "alt_text": "Welcome to Barking Timbers Pet Friendly Park sign with dog agility equipment.",
        "public_id": "01a03ed0-7bf5-74b9-931b-2546e890fc03",
        "storage_key": "property/6767906449165602/01a03ed0-7bf5-74b9-931b-2546e890fc03.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy our dedicated pet-friendly park, \"Barking Timbers,\" featuring agility equipment for your furry friends to play and explore.",
      "link": "",
      "alt_text": "Welcome to Barking Timbers Pet Friendly Park sign with dog agility equipment.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ba169b9c-7103-45f7-9bd3-1d935b56c505",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/01a03ed0-75cd-73bc-9d42-6db0ed67a8d0.webp",
      "image_media": {
        "alt_text": "Dog park agility equipment with ramps and a jump obstacle.",
        "public_id": "01a03ed0-75cd-73bc-9d42-6db0ed67a8d0",
        "storage_key": "property/6767906449165602/01a03ed0-75cd-73bc-9d42-6db0ed67a8d0.webp",
        "width": 3072,
        "height": 2458
      },
      "title": "Community",
      "description": "Enjoy our on-site dog park, complete with agility equipment for your furry friends to play and exercise.",
      "link": "",
      "alt_text": "Dog park agility equipment with ramps and a jump obstacle.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8ecc09f1-8073-4dd8-ab82-94f0f536c50b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/01a03ed0-6d54-74fa-aba0-af19365eec0f.webp",
      "image_media": {
        "alt_text": "Welcome to Barking Timbers Pet Friendly Park sign with agility equipment.",
        "public_id": "01a03ed0-6d54-74fa-aba0-af19365eec0f",
        "storage_key": "property/6767906449165602/01a03ed0-6d54-74fa-aba0-af19365eec0f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Discover our dedicated pet-friendly park, 'Barking Timbers,' featuring agility equipment for your furry friends to enjoy. A perfect place for pets to play and socialize.",
      "link": "",
      "alt_text": "Welcome to Barking Timbers Pet Friendly Park sign with agility equipment.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ed73645e-159e-432e-b159-341a684345f0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/01a03ed0-69b0-740c-b8df-1014096c0b78.webp",
      "image_media": {
        "alt_text": "Welcome to Barking Timbers Pet Friendly Park sign with agility equipment in the background.",
        "public_id": "01a03ed0-69b0-740c-b8df-1014096c0b78",
        "storage_key": "property/6767906449165602/01a03ed0-69b0-740c-b8df-1014096c0b78.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Discover our on-site pet park, perfect for your furry friends to play and socialize. This dedicated space offers agility equipment and plenty of room to roam.",
      "link": "",
      "alt_text": "Welcome to Barking Timbers Pet Friendly Park sign with agility equipment in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_3c77df80-f4c8-47d7-be8a-12ceea219f8c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/01a03ed0-69dc-764d-b696-b199459b1098.webp",
      "image_media": {
        "alt_text": "Barking Timbers Pet Friendly Park with agility equipment and a fence.",
        "public_id": "01a03ed0-69dc-764d-b696-b199459b1098",
        "storage_key": "property/6767906449165602/01a03ed0-69dc-764d-b696-b199459b1098.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to Barking Timbers, our pet-friendly park where your furry friends can play and explore. Featuring agility equipment and a secure, fenced area.",
      "link": "",
      "alt_text": "Barking Timbers Pet Friendly Park with agility equipment and a fence.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e34bf2ed-7c8b-4045-bd4f-36c68ce5d8af",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/01a03ecd-84d9-7634-b5cf-eeb18f0f8519.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with green siding and brick accents.",
        "public_id": "01a03ecd-84d9-7634-b5cf-eeb18f0f8519",
        "storage_key": "property/6767906449165602/01a03ecd-84d9-7634-b5cf-eeb18f0f8519.webp",
        "width": 2458,
        "height": 3072
      },
      "title": "Community",
      "description": "Charming apartment buildings featuring a blend of green siding and classic brickwork, offering a welcoming exterior for residents.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with green siding and brick accents.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_faf455fb-153a-4934-8656-8c2f32312d3d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/01a03ec2-3dbf-746d-9f2d-4b6c717913a7.webp",
      "image_media": {
        "alt_text": "Modern living room with a sectional sofa facing a wall-mounted TV and a linear fireplace.",
        "public_id": "01a03ec2-3dbf-746d-9f2d-4b6c717913a7",
        "storage_key": "property/6767906449165602/01a03ec2-3dbf-746d-9f2d-4b6c717913a7.webp",
        "width": 3072,
        "height": 2458
      },
      "title": "Apartment",
      "description": "Spacious and stylish living room featuring a comfortable sectional sofa, a sleek linear fireplace, and modern decor, perfect for relaxation and entertaining.",
      "link": "",
      "alt_text": "Modern living room with a sectional sofa facing a wall-mounted TV and a linear fireplace.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_414adaf3-df7a-42d9-a8d0-021695c44af7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/01a03ec2-3c8d-7569-a4d0-ea0866d26d71.webp",
      "image_media": {
        "alt_text": "Spacious communal lounge area with a large sectional sofa, armchair, fireplace, and TV.",
        "public_id": "01a03ec2-3c8d-7569-a4d0-ea0866d26d71",
        "storage_key": "property/6767906449165602/01a03ec2-3c8d-7569-a4d0-ea0866d26d71.webp",
        "width": 3072,
        "height": 2458
      },
      "title": "Community",
      "description": "Relax and unwind in our beautifully appointed communal lounge, featuring comfortable seating, a modern fireplace, and entertainment options.",
      "link": "",
      "alt_text": "Spacious communal lounge area with a large sectional sofa, armchair, fireplace, and TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_91397784-cdb1-4690-99e3-dcf30aedb71c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/01a03ec2-16a0-700a-9bc8-c327b8c42c01.webp",
      "image_media": {
        "alt_text": "Comfortable community lounge area with large sectional sofa, fireplace, and TV.",
        "public_id": "01a03ec2-16a0-700a-9bc8-c327b8c42c01",
        "storage_key": "property/6767906449165602/01a03ec2-16a0-700a-9bc8-c327b8c42c01.webp",
        "width": 3072,
        "height": 2458
      },
      "title": "Community",
      "description": "Relax and unwind in our spacious community lounge, featuring a cozy fireplace, large screen TV, and ample seating.",
      "link": "",
      "alt_text": "Comfortable community lounge area with large sectional sofa, fireplace, and TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f6b0fe33-210c-4285-84f2-039cb62a19d9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/01a03ec1-fe92-77c9-8c85-329cb3410036.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and apartment buildings in the background.",
        "public_id": "01a03ec1-fe92-77c9-8c85-329cb3410036",
        "storage_key": "property/6767906449165602/01a03ec1-fe92-77c9-8c85-329cb3410036.webp",
        "width": 3072,
        "height": 2458
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, a perfect place to relax and unwind.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8a9140d4-4d7e-4301-adb8-1400dc9924b4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/01a03ec1-e5fc-76b5-b4e0-e54da30cd2de.webp",
      "image_media": {
        "alt_text": "Modern apartment lounge area with a large sectional sofa, fireplace, TV, and a kitchen island with a sink.",
        "public_id": "01a03ec1-e5fc-76b5-b4e0-e54da30cd2de",
        "storage_key": "property/6767906449165602/01a03ec1-e5fc-76b5-b4e0-e54da30cd2de.webp",
        "width": 3072,
        "height": 2458
      },
      "title": "Community",
      "description": "Relax and unwind in this stylish lounge, featuring a fully equipped kitchen island, a cozy fireplace, and a large television for entertainment.",
      "link": "",
      "alt_text": "Modern apartment lounge area with a large sectional sofa, fireplace, TV, and a kitchen island with a sink.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_05295454-0bfc-4067-a2fb-644dbc0c62c8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/01a03ec1-95c6-70ab-a261-fe16055a7cd5.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with brick and green siding.",
        "public_id": "01a03ec1-95c6-70ab-a261-fe16055a7cd5",
        "storage_key": "property/6767906449165602/01a03ec1-95c6-70ab-a261-fe16055a7cd5.webp",
        "width": 3072,
        "height": 2458
      },
      "title": "Community",
      "description": "Showcasing the exterior of apartment buildings with a blend of brick and green siding, set against a backdrop of a blue sky with clouds.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with brick and green siding.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0384e6ce-ebcd-4b94-a3e3-1936bbc5dedd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/01a03ec1-5a2c-726d-aa0d-d1cabcc3aec0.webp",
      "image_media": {
        "alt_text": "Apartment building entrance with brick facade and landscaping.",
        "public_id": "01a03ec1-5a2c-726d-aa0d-d1cabcc3aec0",
        "storage_key": "property/6767906449165602/01a03ec1-5a2c-726d-aa0d-d1cabcc3aec0.webp",
        "width": 3072,
        "height": 2458
      },
      "title": "Community",
      "description": "The welcoming entrance of the apartment complex, featuring red brick architecture and lush greenery.",
      "link": "",
      "alt_text": "Apartment building entrance with brick facade and landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ff0e5572-cddf-44f6-b251-b1ee08a86317",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/01a03ec1-4943-71cc-a4ad-fcd2c295cedf.webp",
      "image_media": {
        "alt_text": "Exterior of apartment buildings with green siding and brick accents.",
        "public_id": "01a03ec1-4943-71cc-a4ad-fcd2c295cedf",
        "storage_key": "property/6767906449165602/01a03ec1-4943-71cc-a4ad-fcd2c295cedf.webp",
        "width": 2458,
        "height": 3072
      },
      "title": "Community",
      "description": "Charming apartment exteriors featuring a mix of green siding and classic red brick, surrounded by well-maintained landscaping.",
      "link": "",
      "alt_text": "Exterior of apartment buildings with green siding and brick accents.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_cf722560-8884-4531-93ad-5c61361464c5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/01a03ec0-1d6a-776f-ba0c-47d2eb7afd21.webp",
      "image_media": {
        "alt_text": "Exterior of a building with multiple garage doors.",
        "public_id": "01a03ec0-1d6a-776f-ba0c-47d2eb7afd21",
        "storage_key": "property/6767906449165602/01a03ec0-1d6a-776f-ba0c-47d2eb7afd21.webp",
        "width": 3072,
        "height": 2458
      },
      "title": "Community",
      "description": "Exterior view of a row of individual garages. These can be used for additional storage or parking.",
      "link": "",
      "alt_text": "Exterior of a building with multiple garage doors.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_344611e4-f2e9-4268-bc3a-455a83d85811",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/01a03ec0-1447-75bc-a546-578d1f066a0d.webp",
      "image_media": {
        "alt_text": "Exterior of apartment building with picnic table and grill in foreground.",
        "public_id": "01a03ec0-1447-75bc-a546-578d1f066a0d",
        "storage_key": "property/6767906449165602/01a03ec0-1447-75bc-a546-578d1f066a0d.webp",
        "width": 3072,
        "height": 2458
      },
      "title": "Community",
      "description": "Enjoy outdoor gatherings with the picnic area and BBQ grill available for residents.",
      "link": "",
      "alt_text": "Exterior of apartment building with picnic table and grill in foreground.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_41cb21b0-d9bb-4d2b-a8c5-5f8eea2b3429",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/01a03ebf-ee72-7058-a43e-7d2962763a7b.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with green siding and brick bases.",
        "public_id": "01a03ebf-ee72-7058-a43e-7d2962763a7b",
        "storage_key": "property/6767906449165602/01a03ebf-ee72-7058-a43e-7d2962763a7b.webp",
        "width": 3072,
        "height": 2458
      },
      "title": "Community",
      "description": "Spacious apartment buildings featuring a charming blend of green siding and classic brickwork, set against a backdrop of blue skies and fluffy clouds.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with green siding and brick bases.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d1d7cae4-7a3e-4602-9147-0817e08772a0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/01a03ebe-ab19-712d-a937-7af5e0dc0474.webp",
      "image_media": {
        "alt_text": "Exterior of Cross Timber Apartment Homes building entrance with brick facade and landscaping.",
        "public_id": "01a03ebe-ab19-712d-a937-7af5e0dc0474",
        "storage_key": "property/6767906449165602/01a03ebe-ab19-712d-a937-7af5e0dc0474.webp",
        "width": 3072,
        "height": 2458
      },
      "title": "Community",
      "description": "Welcome to Cross Timber Apartment Homes. Experience comfortable living in our well-maintained community with inviting exteriors and beautiful landscaping.",
      "link": "",
      "alt_text": "Exterior of Cross Timber Apartment Homes building entrance with brick facade and landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_56aa4c82-bdcb-4337-872e-7c4809ce101c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/01a03ebc-0fe3-73aa-a5ca-63ad77952247.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white countertops, black appliances, and a sign that says \"let's stay home.\"",
        "public_id": "01a03ebc-0fe3-73aa-a5ca-63ad77952247",
        "storage_key": "property/6767906449165602/01a03ebc-0fe3-73aa-a5ca-63ad77952247.webp",
        "width": 3072,
        "height": 2458
      },
      "title": "Apartment",
      "description": "Beautifully renovated kitchen featuring sleek white countertops, a full suite of modern black appliances, and ample cabinet space. Perfect for cooking and entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with white countertops, black appliances, and a sign that says \"let's stay home.\"",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e1b36526-b727-40e0-bb81-a4b2a4667db1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/01a03ebb-ffbc-7112-8f26-6e936b601588.webp",
      "image_media": {
        "alt_text": "Modern bathroom with gray vanity, white countertop, and chrome faucet.",
        "public_id": "01a03ebb-ffbc-7112-8f26-6e936b601588",
        "storage_key": "property/6767906449165602/01a03ebb-ffbc-7112-8f26-6e936b601588.webp",
        "width": 3072,
        "height": 2458
      },
      "title": "Apartment",
      "description": "Experience luxury in this beautifully appointed bathroom, featuring a spacious vanity, elegant countertop, and modern fixtures.",
      "link": "",
      "alt_text": "Modern bathroom with gray vanity, white countertop, and chrome faucet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4ee10f72-132c-4c8d-906a-8f299ce1e68e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/01a03ebb-f780-740e-98cd-64827f670f65.webp",
      "image_media": {
        "alt_text": "Bedroom with a closet and a view into the bathroom.",
        "public_id": "01a03ebb-f780-740e-98cd-64827f670f65",
        "storage_key": "property/6767906449165602/01a03ebb-f780-740e-98cd-64827f670f65.webp",
        "width": 3072,
        "height": 2458
      },
      "title": "Apartment",
      "description": "A cozy bedroom featuring a spacious closet and a peek into the en-suite bathroom with modern fixtures and vanity.",
      "link": "",
      "alt_text": "Bedroom with a closet and a view into the bathroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5ecf8fc2-ea5b-428f-8015-a48e2f670b67",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/01a03ebb-e9b2-732f-99dd-7e0b6d464df0.webp",
      "image_media": {
        "alt_text": "Cross Timber apartment homes monument sign",
        "public_id": "01a03ebb-e9b2-732f-99dd-7e0b6d464df0",
        "storage_key": "property/6767906449165602/01a03ebb-e9b2-732f-99dd-7e0b6d464df0.webp",
        "width": 3072,
        "height": 2458
      },
      "title": "Community",
      "description": "Welcome to Cross Timber apartment homes, a beautiful community featuring well-appointed living spaces and excellent amenities.",
      "link": "",
      "alt_text": "Cross Timber apartment homes monument sign",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_75c3decd-2a83-4418-a56d-dfa60f9c4a6d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/01a03ebb-f079-76d6-bb6d-a47f9adebabe.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-sized bed, headboard, nightstand, lamp, ceiling fan, and window with curtains.",
        "public_id": "01a03ebb-f079-76d6-bb6d-a47f9adebabe",
        "storage_key": "property/6767906449165602/01a03ebb-f079-76d6-bb6d-a47f9adebabe.webp",
        "width": 3072,
        "height": 2458
      },
      "title": "Apartment",
      "description": "Comfortable and inviting bedroom featuring a plush queen-sized bed, a stylish headboard, and a bedside table with a lamp. The room is enhanced by a ceiling fan and natural light from the window.",
      "link": "",
      "alt_text": "Bedroom with a queen-sized bed, headboard, nightstand, lamp, ceiling fan, and window with curtains.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f2178ce1-1036-424b-9d8f-b7a91f213104",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/01a03ebb-c634-7406-8c98-25af31c2e4d7.webp",
      "image_media": {
        "alt_text": "Gross Timber apartment homes monument sign with landscaping and buildings in the background.",
        "public_id": "01a03ebb-c634-7406-8c98-25af31c2e4d7",
        "storage_key": "property/6767906449165602/01a03ebb-c634-7406-8c98-25af31c2e4d7.webp",
        "width": 3072,
        "height": 2458
      },
      "title": "Community",
      "description": "Welcome to Gross Timber apartment homes. Discover a new standard of apartment living in this beautiful community.",
      "link": "",
      "alt_text": "Gross Timber apartment homes monument sign with landscaping and buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d77a4190-d291-43a1-b821-7ab4c6ac3cec",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/01a03ebb-c0ff-7433-885e-ee0907c3ccc3.webp",
      "image_media": {
        "alt_text": "Exterior of apartment buildings with red brick and green accents, under a blue sky with clouds.",
        "public_id": "01a03ebb-c0ff-7433-885e-ee0907c3ccc3",
        "storage_key": "property/6767906449165602/01a03ebb-c0ff-7433-885e-ee0907c3ccc3.webp",
        "width": 3072,
        "height": 2458
      },
      "title": "Community",
      "description": "Welcome to the beautifully maintained exteriors of our apartment community, featuring classic red brick architecture and lush landscaping.",
      "link": "",
      "alt_text": "Exterior of apartment buildings with red brick and green accents, under a blue sky with clouds.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_61f2c5dc-7868-4e76-b099-bfb1584f3fb6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/01a03eba-e1c1-7224-9377-f01f4a7de128.webp",
      "image_media": {
        "alt_text": "Outdoor grilling area with a stone fireplace, stainless steel grill, picnic table, and seating.",
        "public_id": "01a03eba-e1c1-7224-9377-f01f4a7de128",
        "storage_key": "property/6767906449165602/01a03eba-e1c1-7224-9377-f01f4a7de128.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy outdoor entertaining with our community's grilling station, complete with a stone fireplace and ample seating for residents.",
      "link": "",
      "alt_text": "Outdoor grilling area with a stone fireplace, stainless steel grill, picnic table, and seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_fa3cd01d-e0a5-4d85-b6b8-277c6efab0b0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/01a03eba-e536-75a4-83b0-e3326cf1648d.webp",
      "image_media": {
        "alt_text": "Outdoor seating area with picnic table and fireplace near grills.",
        "public_id": "01a03eba-e536-75a4-83b0-e3326cf1648d",
        "storage_key": "property/6767906449165602/01a03eba-e536-75a4-83b0-e3326cf1648d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy outdoor living with a communal picnic area featuring a stone fireplace, grills, and comfortable seating.",
      "link": "",
      "alt_text": "Outdoor seating area with picnic table and fireplace near grills.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5e16a25e-8e21-43eb-89c9-daed7ef77a7f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/01a03eba-dfdb-744b-b5de-ceaa640c4ff0.webp",
      "image_media": {
        "alt_text": "Outdoor kitchen area with grill and fireplace, plus a table and chairs under an umbrella.",
        "public_id": "01a03eba-dfdb-744b-b5de-ceaa640c4ff0",
        "storage_key": "property/6767906449165602/01a03eba-dfdb-744b-b5de-ceaa640c4ff0.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy al fresco dining at our outdoor kitchen, complete with a built-in grill and a cozy fireplace. Perfect for entertaining guests or relaxing with family.",
      "link": "",
      "alt_text": "Outdoor kitchen area with grill and fireplace, plus a table and chairs under an umbrella.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_446be3ee-c66e-4698-9d5b-0a6b77a7f913",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/01a03eba-bf35-7085-b080-d63c527feb62.webp",
      "image_media": {
        "alt_text": "Lobby with fireplace and television above, seating areas with sofas and chairs, and a coffee table.",
        "public_id": "01a03eba-bf35-7085-b080-d63c527feb62",
        "storage_key": "property/6767906449165602/01a03eba-bf35-7085-b080-d63c527feb62.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "The spacious and well-appointed lobby features a cozy fireplace, a large television, comfortable seating areas with sofas and chairs, and a stylish coffee table, creating a welcoming atmosphere.",
      "link": "",
      "alt_text": "Lobby with fireplace and television above, seating areas with sofas and chairs, and a coffee table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6168a5bf-3281-4d9d-9eb2-f470495ea1b3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/01a03eba-c787-7245-8805-a312817ee575.webp",
      "image_media": {
        "alt_text": "Lobby seating area with couches and a coffee table.",
        "public_id": "01a03eba-c787-7245-8805-a312817ee575",
        "storage_key": "property/6767906449165602/01a03eba-c787-7245-8805-a312817ee575.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in our spacious and elegant lobby, featuring comfortable seating and a modern design.",
      "link": "",
      "alt_text": "Lobby seating area with couches and a coffee table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e061b74e-f7cd-42ba-a18d-0d8ee1ba6c14",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/01a03eba-bde7-7739-9771-633a90c07768.webp",
      "image_media": {
        "alt_text": "Lobby with seating area, front desk, and view of the pool area through glass doors.",
        "public_id": "01a03eba-bde7-7739-9771-633a90c07768",
        "storage_key": "property/6767906449165602/01a03eba-bde7-7739-9771-633a90c07768.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Spacious and modern lobby with comfortable seating, a front desk, and a large fireplace with a mounted TV. Through the glass doors, you can see the inviting pool area.",
      "link": "",
      "alt_text": "Lobby with seating area, front desk, and view of the pool area through glass doors.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d8f13710-5cd8-498d-b4e0-2c024376ab42",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/01a03eba-c13f-72cb-9fd7-e8d821e7e669.webp",
      "image_media": {
        "alt_text": "Clubhouse living room with fireplace and seating areas.",
        "public_id": "01a03eba-c13f-72cb-9fd7-e8d821e7e669",
        "storage_key": "property/6767906449165602/01a03eba-c13f-72cb-9fd7-e8d821e7e669.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in the beautifully appointed clubhouse, featuring a cozy fireplace, comfortable seating, and ample space for socializing.",
      "link": "",
      "alt_text": "Clubhouse living room with fireplace and seating areas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_04fa3379-7edb-4833-b60e-ec705bc2e6ba",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/01a03eba-b976-756e-a834-0582ddbcb6a6.webp",
      "image_media": {
        "alt_text": "Crown Pointe apartment complex entrance monument and signage",
        "public_id": "01a03eba-b976-756e-a834-0582ddbcb6a6",
        "storage_key": "property/6767906449165602/01a03eba-b976-756e-a834-0582ddbcb6a6.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Welcome to Crown Pointe apartments, featuring beautiful landscaping and clear signage at the entrance.",
      "link": "",
      "alt_text": "Crown Pointe apartment complex entrance monument and signage",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2d2a536e-8945-466c-9861-464b147dc786",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/01a03eba-a665-750b-9035-9b317c9eccfe.webp",
      "image_media": {
        "alt_text": "Sidewalk leading to apartment buildings with green lawn and trees.",
        "public_id": "01a03eba-a665-750b-9035-9b317c9eccfe",
        "storage_key": "property/6767906449165602/01a03eba-a665-750b-9035-9b317c9eccfe.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a stroll through our beautifully landscaped grounds, featuring a charming sidewalk lined with mature trees and lush green lawns, leading to the apartment buildings.",
      "link": "",
      "alt_text": "Sidewalk leading to apartment buildings with green lawn and trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_608328b6-333c-41c1-ac89-6daeaba65907",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/01a03eba-a71d-77ba-ad5c-2d5bbe071d5e.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, elliptical, and free weights.",
        "public_id": "01a03eba-a71d-77ba-ad5c-2d5bbe071d5e",
        "storage_key": "property/6767906449165602/01a03eba-a71d-77ba-ad5c-2d5bbe071d5e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring cardio equipment and free weights.",
      "link": "",
      "alt_text": "Fitness center with treadmills, elliptical, and free weights.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5bf5f4cf-1a85-4db5-b683-e4aa1c8c226d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/01a03eba-ad0b-7588-9230-7a44439da52f.webp",
      "image_media": {
        "alt_text": "Stylish seating area with fireplace and TV in apartment building lobby.",
        "public_id": "01a03eba-ad0b-7588-9230-7a44439da52f",
        "storage_key": "property/6767906449165602/01a03eba-ad0b-7588-9230-7a44439da52f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in our beautifully appointed community lounge, featuring a cozy fireplace, large screen TV, and comfortable seating.",
      "link": "",
      "alt_text": "Stylish seating area with fireplace and TV in apartment building lobby.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a5d73132-a504-44ad-8169-53b1a9deb99a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/01a03eba-9eb4-7778-a025-8144dd84e8a4.webp",
      "image_media": {
        "alt_text": "Crown Pointe apartment complex entrance sign with brick pillars and landscaping.",
        "public_id": "01a03eba-9eb4-7778-a025-8144dd84e8a4",
        "storage_key": "property/6767906449165602/01a03eba-9eb4-7778-a025-8144dd84e8a4.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to Crown Pointe, a premier apartment community featuring beautiful landscaping and elegant architecture. Experience comfortable living at its finest.",
      "link": "",
      "alt_text": "Crown Pointe apartment complex entrance sign with brick pillars and landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_de46907b-4d30-4465-b9a9-84659e8d3416",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/01a03eba-a3cf-752b-a9c7-1fa0e7423b57.webp",
      "image_media": {
        "alt_text": "Balcony with two chairs and decorative pillows, overlooking apartment buildings.",
        "public_id": "01a03eba-a3cf-752b-a9c7-1fa0e7423b57",
        "storage_key": "property/6767906449165602/01a03eba-a3cf-752b-a9c7-1fa0e7423b57.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy your morning coffee or evening breeze on your private balcony, complete with comfortable seating and decorative pillows.",
      "link": "",
      "alt_text": "Balcony with two chairs and decorative pillows, overlooking apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_616dfb39-bfd3-4b55-a5a5-23cdf6fef634",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/01a03eba-9a28-77be-b7a8-238034f31667.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment building with balconies and manicured landscaping.",
        "public_id": "01a03eba-9a28-77be-b7a8-238034f31667",
        "storage_key": "property/6767906449165602/01a03eba-9a28-77be-b7a8-238034f31667.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Charming apartment building exterior featuring multiple levels of balconies and well-maintained green spaces.",
      "link": "",
      "alt_text": "Exterior view of apartment building with balconies and manicured landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a77c623d-5cea-47a5-b6f4-c87e94d888cf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/01a03eba-9887-765a-8521-cfdc75fd03b6.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with a walking path and manicured lawns.",
        "public_id": "01a03eba-9887-765a-8521-cfdc75fd03b6",
        "storage_key": "property/6767906449165602/01a03eba-9887-765a-8521-cfdc75fd03b6.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Beautifully landscaped grounds with a paved walkway leading to apartment buildings, showcasing the exterior architecture and well-maintained community spaces.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with a walking path and manicured lawns.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_140086d2-337a-4963-beae-5a53da226293",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019e8210-076f-77dd-8487-55f8593fd71b.webp",
      "image_media": {
        "alt_text": "Spacious and modern leasing office and resident lounge area with seating and fireplace.",
        "public_id": "019e8210-076f-77dd-8487-55f8593fd71b",
        "storage_key": "property/6767906449165602/019e8210-076f-77dd-8487-55f8593fd71b.webp",
        "width": 2000,
        "height": 1000
      },
      "title": "Community",
      "description": "Discover a welcoming atmosphere in our leasing office and resident lounge, featuring comfortable seating, a cozy fireplace, and a dedicated workspace.",
      "link": "",
      "alt_text": "Spacious and modern leasing office and resident lounge area with seating and fireplace.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a68462d1-4463-41e2-9719-5d2bce15c73f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d4ea2-6832-72aa-82f4-8fbdc4376757.webp",
      "image_media": {
        "alt_text": "Crown Pointe apartment complex entrance with monument sign and building exterior.",
        "public_id": "019d4ea2-6832-72aa-82f4-8fbdc4376757",
        "storage_key": "property/6767906449165602/019d4ea2-6832-72aa-82f4-8fbdc4376757.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Welcome to Crown Pointe, where you can find a community that offers comfort and convenience. This image shows the property's monument sign and a glimpse of the apartment buildings.",
      "link": "",
      "alt_text": "Crown Pointe apartment complex entrance with monument sign and building exterior.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d8bcf414-9c33-4811-a87d-541d4d92cfc3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d4ea2-37b8-708b-941a-b668726479a9.webp",
      "image_media": {
        "alt_text": "Stylish communal lounge with fireplace, comfortable seating, and a large TV.",
        "public_id": "019d4ea2-37b8-708b-941a-b668726479a9",
        "storage_key": "property/6767906449165602/019d4ea2-37b8-708b-941a-b668726479a9.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Relax and unwind in our beautifully appointed communal lounge, featuring a cozy fireplace, elegant seating, and entertainment options.",
      "link": "",
      "alt_text": "Stylish communal lounge with fireplace, comfortable seating, and a large TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_51bcdcc0-3f10-47d3-8099-01462d348ff9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d4ea2-2ebf-7662-8a39-a5f2b0a0f716.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and apartment buildings in the background.",
        "public_id": "019d4ea2-2ebf-7662-8a39-a5f2b0a0f716",
        "storage_key": "property/6767906449165602/019d4ea2-2ebf-7662-8a39-a5f2b0a0f716.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Enjoy a refreshing swim in our sparkling outdoor pool, surrounded by comfortable lounge chairs and beautiful landscaping.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_947225cb-680b-4377-82a0-d1be9981273b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d4ea2-25c7-7030-a349-a290758af495.webp",
      "image_media": {
        "alt_text": "Modern apartment building lobby with comfortable seating areas and decorative accents.",
        "public_id": "019d4ea2-25c7-7030-a349-a290758af495",
        "storage_key": "property/6767906449165602/019d4ea2-25c7-7030-a349-a290758af495.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Relax and unwind in the beautifully appointed lobby of our apartment community, featuring plush seating, stylish decor, and ample natural light.",
      "link": "",
      "alt_text": "Modern apartment building lobby with comfortable seating areas and decorative accents.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c19546fa-4d18-416b-abcc-93cb4ad15cae",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d4ea1-fad1-73cd-bda5-7044daedd430.webp",
      "image_media": {
        "alt_text": "Modern apartment community lobby with seating area and view of the pool.",
        "public_id": "019d4ea1-fad1-73cd-bda5-7044daedd430",
        "storage_key": "property/6767906449165602/019d4ea1-fad1-73cd-bda5-7044daedd430.webp",
        "width": 2048,
        "height": 1152
      },
      "title": "Community",
      "description": "Lobby area of a modern apartment community, featuring comfortable seating, a dining table, and views of the outdoor pool.",
      "link": "",
      "alt_text": "Modern apartment community lobby with seating area and view of the pool.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_3c1f043d-3390-4e0d-b4fe-453d05aa146b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d4ea1-ed5b-7658-ab86-4063dfc7e7b1.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, nightstand, and dresser.",
        "public_id": "019d4ea1-ed5b-7658-ab86-4063dfc7e7b1",
        "storage_key": "property/6767906449165602/019d4ea1-ed5b-7658-ab86-4063dfc7e7b1.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable king-size bed with decorative pillows, a wooden nightstand with a lamp, and a large dresser for ample storage.",
      "link": "",
      "alt_text": "Bedroom with a king-size bed, nightstand, and dresser.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1dea0718-cd97-45db-b304-01efe11d2894",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d4ea1-d84b-754a-bbe4-46dfb6570c4e.webp",
      "image_media": {
        "alt_text": "Queen-size bed with grey duvet and decorative pillows in a bedroom with city skyline art.",
        "public_id": "019d4ea1-d84b-754a-bbe4-46dfb6570c4e",
        "storage_key": "property/6767906449165602/019d4ea1-d84b-754a-bbe4-46dfb6570c4e.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Relax and unwind in this beautifully appointed bedroom, featuring a comfortable queen-size bed and stylish decor.",
      "link": "",
      "alt_text": "Queen-size bed with grey duvet and decorative pillows in a bedroom with city skyline art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_30353c1a-687d-45b5-9b47-a715d436131d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d4ea1-a4b7-7408-bebd-c4923438da5d.webp",
      "image_media": {
        "alt_text": "Bathroom with a bathtub, shower, toilet, and vanity with sink and mirror.",
        "public_id": "019d4ea1-a4b7-7408-bebd-c4923438da5d",
        "storage_key": "property/6767906449165602/019d4ea1-a4b7-7408-bebd-c4923438da5d.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "A clean and functional bathroom featuring a bathtub with a shower, a toilet, and a vanity with a sink and mirror. Includes decorative accents.",
      "link": "",
      "alt_text": "Bathroom with a bathtub, shower, toilet, and vanity with sink and mirror.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4c21adb8-c71d-43af-a578-2d887ee27e7e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d4ea1-a298-73a6-959f-80a569dc2040.webp",
      "image_media": {
        "alt_text": "Comfortable living room with leather couch, coffee table, and view into the kitchen with bar seating.",
        "public_id": "019d4ea1-a298-73a6-959f-80a569dc2040",
        "storage_key": "property/6767906449165602/019d4ea1-a298-73a6-959f-80a569dc2040.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Relax in the spacious living area, perfect for entertaining, with an open view to the kitchen and convenient bar seating.",
      "link": "",
      "alt_text": "Comfortable living room with leather couch, coffee table, and view into the kitchen with bar seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4a03df8a-6fa2-4f95-8fd7-8394f2a586da",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019cfb40-70ac-7089-a4d8-8c4ba23720f1.webp",
      "image_media": {
        "alt_text": "Living room with a fireplace, coffee table, and sofa.",
        "public_id": "019cfb40-70ac-7089-a4d8-8c4ba23720f1",
        "storage_key": "property/6767906449165602/019cfb40-70ac-7089-a4d8-8c4ba23720f1.webp",
        "width": 1240,
        "height": 827
      },
      "title": "Apartment",
      "description": "Cozy living room featuring a stone fireplace, comfortable seating, and decorative accents.",
      "link": "",
      "alt_text": "Living room with a fireplace, coffee table, and sofa.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b6d0fde0-4190-4932-a75e-84b3d65d3e38",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019cfb40-5b47-7420-ba4f-e0f360470bb7.webp",
      "image_media": {
        "alt_text": "Crown Pointe apartment complex monument sign with brick pillar and landscaping.",
        "public_id": "019cfb40-5b47-7420-ba4f-e0f360470bb7",
        "storage_key": "property/6767906449165602/019cfb40-5b47-7420-ba4f-e0f360470bb7.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Welcome to Crown Pointe, where comfort and convenience meet. Discover our beautiful apartment homes and vibrant community amenities.",
      "link": "",
      "alt_text": "Crown Pointe apartment complex monument sign with brick pillar and landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ca5d2a2f-ee93-4dbf-86c7-370c565d4571",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019cfb3f-d01c-709d-852e-1126673cd49c.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a table with umbrellas.",
        "public_id": "019cfb3f-d01c-709d-852e-1126673cd49c",
        "storage_key": "property/6767906449165602/019cfb3f-d01c-709d-852e-1126673cd49c.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in the sparkling outdoor swimming pool, surrounded by comfortable lounge chairs and shaded seating areas.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and a table with umbrellas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d23b36f6-8bad-451b-98d4-23aeafd585c3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019cfb3f-c28f-7699-b448-b90282bebc91.webp",
      "image_media": {
        "alt_text": "Gym with treadmills, elliptical machines, and free weights.",
        "public_id": "019cfb3f-c28f-7699-b448-b90282bebc91",
        "storage_key": "property/6767906449165602/019cfb3f-c28f-7699-b448-b90282bebc91.webp",
        "width": 1039,
        "height": 690
      },
      "title": "Community",
      "description": "State-of-the-art fitness center with cardio machines and weights, available for resident use.",
      "link": "",
      "alt_text": "Gym with treadmills, elliptical machines, and free weights.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2aca112a-841d-4fad-b33d-d43c0df5bb94",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019cfb3f-c3c7-76fd-a967-5dc51d5f01c6.webp",
      "image_media": {
        "alt_text": "Treadmills and exercise equipment in the community gym.",
        "public_id": "019cfb3f-c3c7-76fd-a967-5dc51d5f01c6",
        "storage_key": "property/6767906449165602/019cfb3f-c3c7-76fd-a967-5dc51d5f01c6.webp",
        "width": 272,
        "height": 359
      },
      "title": "Community",
      "description": "Stay active and healthy in our fully equipped fitness center, featuring modern treadmills and strength training machines.",
      "link": "",
      "alt_text": "Treadmills and exercise equipment in the community gym.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_69813815-130b-4c25-a678-09660bb3a2a2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019cfb3f-b980-73a8-965a-401388c27f9a.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with sink, mirror, and toilet.",
        "public_id": "019cfb3f-b980-73a8-965a-401388c27f9a",
        "storage_key": "property/6767906449165602/019cfb3f-b980-73a8-965a-401388c27f9a.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "A bright and clean apartment bathroom featuring a spacious vanity with a large mirror, sink, and ample counter space, along with a toilet and decorative touches.",
      "link": "",
      "alt_text": "Bathroom vanity with sink, mirror, and toilet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f3c23520-db1d-44bf-8870-e19e69aa5f16",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019cfb3f-b6dc-73a1-9661-e2ef57876841.webp",
      "image_media": {
        "alt_text": "Kitchen with white appliances including a microwave, stove, and refrigerator. Features white cabinets with wood trim and a granite countertop.",
        "public_id": "019cfb3f-b6dc-73a1-9661-e2ef57876841",
        "storage_key": "property/6767906449165602/019cfb3f-b6dc-73a1-9661-e2ef57876841.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "A clean and functional kitchen space equipped with modern white appliances, ample cabinet storage, and stylish granite countertops. Perfect for everyday cooking.",
      "link": "",
      "alt_text": "Kitchen with white appliances including a microwave, stove, and refrigerator. Features white cabinets with wood trim and a granite countertop.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8231999f-fed5-4e30-a169-8a1bca9acf59",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019cfb3f-b50e-70bf-a4b6-a8390ac7aac6.webp",
      "image_media": {
        "alt_text": "Kitchen with white cabinets, wooden trim, white appliances, and marble-look countertops.",
        "public_id": "019cfb3f-b50e-70bf-a4b6-a8390ac7aac6",
        "storage_key": "property/6767906449165602/019cfb3f-b50e-70bf-a4b6-a8390ac7aac6.webp",
        "width": 2048,
        "height": 1364
      },
      "title": "Apartment",
      "description": "A clean and functional kitchen featuring white cabinets with wood trim, a white range, a microwave, and marble-look countertops.",
      "link": "",
      "alt_text": "Kitchen with white cabinets, wooden trim, white appliances, and marble-look countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f48cd1bf-ac8f-4875-8c5c-d4d95aaf245f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019cfb3f-a861-750d-9095-881e7766b577.webp",
      "image_media": {
        "alt_text": "A cozy bedroom with a king-sized bed and decorative pillows.",
        "public_id": "019cfb3f-a861-750d-9095-881e7766b577",
        "storage_key": "property/6767906449165602/019cfb3f-a861-750d-9095-881e7766b577.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Relax in comfort in this beautifully appointed bedroom, featuring a plush king-sized bed and tasteful decor.",
      "link": "",
      "alt_text": "A cozy bedroom with a king-sized bed and decorative pillows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7c23f1b3-4208-422c-a29f-e0141af0071d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019cfb3f-954e-734a-abdc-4c99c240dc3a.webp",
      "image_media": {
        "alt_text": "Living room with a sofa, coffee table, and fireplace.",
        "public_id": "019cfb3f-954e-734a-abdc-4c99c240dc3a",
        "storage_key": "property/6767906449165602/019cfb3f-954e-734a-abdc-4c99c240dc3a.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Cozy living room featuring a plush sofa, a decorative fireplace, and a stylish coffee table. Perfect for relaxing and entertaining.",
      "link": "",
      "alt_text": "Living room with a sofa, coffee table, and fireplace.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a0f528dc-add1-4bc7-a4a4-bd82fc1a5d38",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019cfb3f-a28f-76d9-90d8-a7b1c919701f.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, nightstand, and closet.",
        "public_id": "019cfb3f-a28f-76d9-90d8-a7b1c919701f",
        "storage_key": "property/6767906449165602/019cfb3f-a28f-76d9-90d8-a7b1c919701f.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Cozy bedroom featuring a queen-size bed with decorative pillows, a nightstand with a lamp, and a spacious closet.",
      "link": "",
      "alt_text": "Bedroom with a queen-size bed, nightstand, and closet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2cb16b5a-ad96-4b8a-bdc3-1cfb03ad63c2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019cfb3f-a022-7007-a543-3937373bf884.webp",
      "image_media": {
        "alt_text": "Kitchen with wooden cabinets, white stove, and microwave.",
        "public_id": "019cfb3f-a022-7007-a543-3937373bf884",
        "storage_key": "property/6767906449165602/019cfb3f-a022-7007-a543-3937373bf884.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Modern kitchen featuring ample wooden cabinetry, a white stove, and a built-in microwave, perfect for cooking and entertaining.",
      "link": "",
      "alt_text": "Kitchen with wooden cabinets, white stove, and microwave.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1215ab2d-9517-48b5-9d67-5b86e28d1da9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019cfb3f-954d-7028-8c51-613e80444e69.webp",
      "image_media": {
        "alt_text": "Living room with fireplace and large sectional couch",
        "public_id": "019cfb3f-954d-7028-8c51-613e80444e69",
        "storage_key": "property/6767906449165602/019cfb3f-954d-7028-8c51-613e80444e69.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Cozy living room featuring a fireplace, comfortable seating, and elegant decor. Perfect for relaxing or entertaining guests.",
      "link": "",
      "alt_text": "Living room with fireplace and large sectional couch",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_3dd2987c-3ae6-4428-8e32-9c0aa2bffec0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019cfb3f-9fab-77af-8520-ba4664990055.webp",
      "image_media": {
        "alt_text": "Whirlpool refrigerator and microwave in a kitchen with oak cabinets.",
        "public_id": "019cfb3f-9fab-77af-8520-ba4664990055",
        "storage_key": "property/6767906449165602/019cfb3f-9fab-77af-8520-ba4664990055.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "A clean and functional kitchen featuring a Whirlpool refrigerator and microwave, complemented by warm oak cabinetry and granite countertops. Perfect for everyday living.",
      "link": "",
      "alt_text": "Whirlpool refrigerator and microwave in a kitchen with oak cabinets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a6cd5920-b94a-4f4f-9c40-bae207b181fa",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019cfb3f-9496-779d-8363-775fb8fbebdc.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area with a brown leather sofa, coffee table, and breakfast bar with stools.",
        "public_id": "019cfb3f-9496-779d-8363-775fb8fbebdc",
        "storage_key": "property/6767906449165602/019cfb3f-9496-779d-8363-775fb8fbebdc.webp",
        "width": 2048,
        "height": 1152
      },
      "title": "Apartment",
      "description": "Stylish living room featuring a comfortable brown leather sofa and a breakfast bar connecting to the kitchen, perfect for modern living.",
      "link": "",
      "alt_text": "Living room and kitchen area with a brown leather sofa, coffee table, and breakfast bar with stools.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a6fc6e2f-4829-498a-8598-a50793e98120",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019cfb3f-948f-7578-b1ab-b47d0fefef60.webp",
      "image_media": {
        "alt_text": "Property entrance and exterior with landscaping and parking.",
        "public_id": "019cfb3f-948f-7578-b1ab-b47d0fefef60",
        "storage_key": "property/6767906449165602/019cfb3f-948f-7578-b1ab-b47d0fefef60.webp",
        "width": 2000,
        "height": 1000
      },
      "title": "Community",
      "description": "Welcome to the beautifully landscaped entrance of our community, featuring ample parking and attractive building exteriors.",
      "link": "",
      "alt_text": "Property entrance and exterior with landscaping and parking.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_fc997713-672b-42cf-a3ce-b6ce0bad64a5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019cfb3f-957e-752b-912a-a8241df86567.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, elliptical, weight rack, and weight machine.",
        "public_id": "019cfb3f-957e-752b-912a-a8241df86567",
        "storage_key": "property/6767906449165602/019cfb3f-957e-752b-912a-a8241df86567.webp",
        "width": 2048,
        "height": 1152
      },
      "title": "Community",
      "description": "Stay active in our fully equipped fitness center, featuring cardio machines, weight racks, and strength training equipment.",
      "link": "",
      "alt_text": "Fitness center with treadmills, elliptical, weight rack, and weight machine.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_69564766-9e1d-41c0-8217-11cac8b14ada",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019cfb3f-666d-7789-b213-82279672d920.webp",
      "image_media": {
        "alt_text": "Living room with a sofa and kitchen view.",
        "public_id": "019cfb3f-666d-7789-b213-82279672d920",
        "storage_key": "property/6767906449165602/019cfb3f-666d-7789-b213-82279672d920.webp",
        "width": 998,
        "height": 598
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a comfortable sofa and a modern kitchen, perfect for relaxing and entertaining.",
      "link": "",
      "alt_text": "Living room with a sofa and kitchen view.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1227e285-1947-4776-9ce2-09cc40702940",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019cfb3f-662e-77be-8b59-bdb15739b6b9.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area of an apartment with white sofa, modern art, and kitchen island with stools.",
        "public_id": "019cfb3f-662e-77be-8b59-bdb15739b6b9",
        "storage_key": "property/6767906449165602/019cfb3f-662e-77be-8b59-bdb15739b6b9.webp",
        "width": 2000,
        "height": 600
      },
      "title": "Apartment",
      "description": "Stylish living room and open-concept kitchen featuring a comfortable sofa, modern decor, and a fully equipped kitchen with a breakfast bar.",
      "link": "",
      "alt_text": "Living room and kitchen area of an apartment with white sofa, modern art, and kitchen island with stools.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_57d88d76-9436-4ee5-be7b-11aa4a5f1b7e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019cfb3f-661d-74dd-90e9-b0cf54463943.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with green siding and brick bases.",
        "public_id": "019cfb3f-661d-74dd-90e9-b0cf54463943",
        "storage_key": "property/6767906449165602/019cfb3f-661d-74dd-90e9-b0cf54463943.webp",
        "width": 998,
        "height": 598
      },
      "title": "Community",
      "description": "Charming apartment buildings with a modern design featuring green siding and brick accents. Enjoy comfortable living in a beautiful community setting.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with green siding and brick bases.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_77ba3a77-f2d1-4633-ab0a-317a72d66249",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019cfb3f-662e-77be-8b59-c3627aab75d0.webp",
      "image_media": {
        "alt_text": "Modern kitchen with black appliances, white cabinets, and gray island.",
        "public_id": "019cfb3f-662e-77be-8b59-c3627aab75d0",
        "storage_key": "property/6767906449165602/019cfb3f-662e-77be-8b59-c3627aab75d0.webp",
        "width": 1050,
        "height": 700
      },
      "title": "Apartment",
      "description": "Fully equipped kitchen featuring stainless steel appliances, ample cabinet space, and a breakfast bar island.",
      "link": "",
      "alt_text": "Modern kitchen with black appliances, white cabinets, and gray island.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_59b272fe-f2ec-4d1b-b73c-f5336c1b7f23",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019cfb3f-346d-727b-a308-63c8c70708e0.webp",
      "image_media": {
        "alt_text": "Outdoor seating area with picnic tables and a stone fireplace and grill.",
        "public_id": "019cfb3f-346d-727b-a308-63c8c70708e0",
        "storage_key": "property/6767906449165602/019cfb3f-346d-727b-a308-63c8c70708e0.webp",
        "width": 500,
        "height": 333
      },
      "title": "Community",
      "description": "Enjoy outdoor gatherings with our community's picnic tables, stone fireplace, and grilling station.",
      "link": "",
      "alt_text": "Outdoor seating area with picnic tables and a stone fireplace and grill.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6adcf159-c97f-4b10-aaaa-29308d8938f6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019cfb3f-346a-730b-916d-b330cabe2851.webp",
      "image_media": {
        "alt_text": "Treadmills and dumbbells in the apartment fitness center.",
        "public_id": "019cfb3f-346a-730b-916d-b330cabe2851",
        "storage_key": "property/6767906449165602/019cfb3f-346a-730b-916d-b330cabe2851.webp",
        "width": 500,
        "height": 333
      },
      "title": "Community",
      "description": "Stay active and energized in our fully-equipped fitness center, featuring state-of-the-art treadmills, elliptical machines, and a wide selection of free weights.",
      "link": "",
      "alt_text": "Treadmills and dumbbells in the apartment fitness center.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_59b641b2-9e15-46af-bbed-bf4ce72172f6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019cfb3e-f4cd-73b0-adb7-38efc4c5e2fb.webp",
      "image_media": {
        "alt_text": "A bedroom with a queen-size bed, dark grey duvet, and decorative pillows. A painting of a cityscape hangs on the wall.",
        "public_id": "019cfb3e-f4cd-73b0-adb7-38efc4c5e2fb",
        "storage_key": "property/6767906449165602/019cfb3e-f4cd-73b0-adb7-38efc4c5e2fb.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Discover comfort in this beautifully appointed bedroom, featuring a plush queen-size bed and elegant decor. The vibrant cityscape art adds a touch of urban sophistication.",
      "link": "",
      "alt_text": "A bedroom with a queen-size bed, dark grey duvet, and decorative pillows. A painting of a cityscape hangs on the wall.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d77ae624-48c4-4aec-b61e-d527e9fcdb06",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019cfb3e-e3cb-710a-910e-a2d25b2cdbd0.webp",
      "image_media": {
        "alt_text": "Living room with a leather sofa and a kitchen view with bar stools.",
        "public_id": "019cfb3e-e3cb-710a-910e-a2d25b2cdbd0",
        "storage_key": "property/6767906449165602/019cfb3e-e3cb-710a-910e-a2d25b2cdbd0.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy this open-concept living space, featuring a comfortable leather sofa and a pass-through to the kitchen, perfect for entertaining guests.",
      "link": "",
      "alt_text": "Living room with a leather sofa and a kitchen view with bar stools.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8a4d75de-44ca-44e9-a7fb-cb5043f32212",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019cfb3e-d962-73bb-b79e-8a0eeee77447.webp",
      "image_media": {
        "alt_text": "Queen-size bed with wrought iron frame, white comforter, and decorative pillows in a bedroom.",
        "public_id": "019cfb3e-d962-73bb-b79e-8a0eeee77447",
        "storage_key": "property/6767906449165602/019cfb3e-d962-73bb-b79e-8a0eeee77447.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a queen-size bed with a decorative wrought iron frame, cozy white linens, and matching nightstands and dresser for ample storage.",
      "link": "",
      "alt_text": "Queen-size bed with wrought iron frame, white comforter, and decorative pillows in a bedroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_63c76100-ba87-42e8-bd1b-c316209050ea",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019cfb3e-e2ea-72f9-b43a-50e3032b0ff8.webp",
      "image_media": {
        "alt_text": "Bathroom with toilet, sink, vanity, and shower curtain.",
        "public_id": "019cfb3e-e2ea-72f9-b43a-50e3032b0ff8",
        "storage_key": "property/6767906449165602/019cfb3e-e2ea-72f9-b43a-50e3032b0ff8.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A clean and functional bathroom featuring a toilet, a sink with a granite countertop, wooden cabinetry, and a shower curtain.",
      "link": "",
      "alt_text": "Bathroom with toilet, sink, vanity, and shower curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_aeca340b-6269-4f10-91ec-395bcc2af968",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019cfb3e-e3cb-710a-910e-a5bb892dff33.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, elliptical, and free weights.",
        "public_id": "019cfb3e-e3cb-710a-910e-a5bb892dff33",
        "storage_key": "property/6767906449165602/019cfb3e-e3cb-710a-910e-a5bb892dff33.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Fully equipped fitness center featuring treadmills, ellipticals, and a full rack of free weights for your workout needs.",
      "link": "",
      "alt_text": "Fitness center with treadmills, elliptical, and free weights.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_91161c2c-2bc5-4ee3-92b8-1bef43e9334a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019cfb3e-d19f-768b-a2c3-a73b4d288e03.webp",
      "image_media": {
        "alt_text": "Kitchen with light wood cabinets, white appliances, and granite countertops.",
        "public_id": "019cfb3e-d19f-768b-a2c3-a73b4d288e03",
        "storage_key": "property/6767906449165602/019cfb3e-d19f-768b-a2c3-a73b4d288e03.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Bright and functional kitchen featuring light wood cabinetry, a full suite of white appliances including a microwave and stove, and elegant granite countertops.",
      "link": "",
      "alt_text": "Kitchen with light wood cabinets, white appliances, and granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ca9ae472-f234-4d35-981d-66f5ab20c819",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019cfb3e-bf86-7078-84cd-2de571d85928.webp",
      "image_media": {
        "alt_text": "Crown Pointe apartment community entrance monument sign with brick pillar and landscaping.",
        "public_id": "019cfb3e-bf86-7078-84cd-2de571d85928",
        "storage_key": "property/6767906449165602/019cfb3e-bf86-7078-84cd-2de571d85928.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Welcome to Crown Pointe, a premier apartment community. Our entrance features a prominent monument sign set amidst lush landscaping and elegant brickwork.",
      "link": "",
      "alt_text": "Crown Pointe apartment community entrance monument sign with brick pillar and landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d209c886-d433-426e-96c5-b5d82e52c26a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019cfb3e-bc30-777d-8633-eb8d966f7231.webp",
      "image_media": {
        "alt_text": "Luxurious communal lounge area with fireplace, large screen TV, comfortable seating, and a chandelier.",
        "public_id": "019cfb3e-bc30-777d-8633-eb8d966f7231",
        "storage_key": "property/6767906449165602/019cfb3e-bc30-777d-8633-eb8d966f7231.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in our beautifully appointed communal lounge. Featuring a large fireplace, entertainment system, and ample seating, it's the perfect space to socialize or enjoy a quiet moment.",
      "link": "",
      "alt_text": "Luxurious communal lounge area with fireplace, large screen TV, comfortable seating, and a chandelier.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f4518c20-9863-4aa2-9adc-ad50a1373c4b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019cfb3e-b18c-715c-8934-27e6b4e9f8eb.webp",
      "image_media": {
        "alt_text": "Kitchen with white refrigerator, wooden cabinets, and white oven.",
        "public_id": "019cfb3e-b18c-715c-8934-27e6b4e9f8eb",
        "storage_key": "property/6767906449165602/019cfb3e-b18c-715c-8934-27e6b4e9f8eb.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Bright and functional kitchen featuring modern appliances and ample cabinet storage.",
      "link": "",
      "alt_text": "Kitchen with white refrigerator, wooden cabinets, and white oven.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_55d9a063-e2b4-456b-be02-5e613dfe11a8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019cfb3e-ac82-7528-a433-37485366c472.webp",
      "image_media": {
        "alt_text": "Spacious resident lounge with fireplace, seating area, and workstations.",
        "public_id": "019cfb3e-ac82-7528-a433-37485366c472",
        "storage_key": "property/6767906449165602/019cfb3e-ac82-7528-a433-37485366c472.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in our resident lounge, featuring a cozy fireplace, comfortable seating, and convenient workstations for your productivity needs.",
      "link": "",
      "alt_text": "Spacious resident lounge with fireplace, seating area, and workstations.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b28daaed-787a-4486-b033-12a7173cf9c4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019cfb3e-a901-72b9-a932-8d1bc808b3cd.webp",
      "image_media": {
        "alt_text": "Kitchen with white appliances, wood cabinets, and laminate flooring.",
        "public_id": "019cfb3e-a901-72b9-a932-8d1bc808b3cd",
        "storage_key": "property/6767906449165602/019cfb3e-a901-72b9-a932-8d1bc808b3cd.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A bright and functional kitchen featuring white appliances, ample cabinet space, and modern laminate flooring, perfect for everyday cooking and entertaining.",
      "link": "",
      "alt_text": "Kitchen with white appliances, wood cabinets, and laminate flooring.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_5ff938b5-eb87-41a4-9ffe-bbeb74d6a1db",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "source": "custom",
      "poi_name": "Topgolf Oklahoma City",
      "poi_type": "Restaurants",
      "poi_address": "13313 Pawnee Dr, Oklahoma City, OK 73114, USA",
      "poi_short_description": "Sprawling entertainment venue with a high-tech driving range & swanky lounge with drinks & games.",
      "poi_long_description": "People say this restaurant offers a fun golfing experience with multiple games to choose from, and a variety of drinks and appetizers. They also highlight the fun atmosphere, suitable for families and groups, and the friendly and helpful staff.\n\nOther reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d2709-1ced-71ca-a6ed-64a68a94cf72.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-1ced-71ca-a6ed-64a68a94cf72",
        "storage_key": "property/6767906449165602/019d2709-1ced-71ca-a6ed-64a68a94cf72.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://topgolf.com/us/oklahoma-city/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17880991546737991946&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "topgolf-oklahoma-city",
      "poi_latitude": "35.6027127",
      "poi_longitude": "-97.5351879",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 11 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 405-607-7154",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d2709-53cd-71da-8ff7-2432d31310c2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-53cd-71da-8ff7-2432d31310c2",
        "storage_key": "property/6767906449165602/019d2709-53cd-71da-8ff7-2432d31310c2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJc0r8qRocsocRCqEU_xILJvg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_9f7e7a3c-b364-42fb-8c95-563396fc6411",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "source": "custom",
      "poi_name": "Main Event Oklahoma City",
      "poi_type": "Restaurants",
      "poi_address": "1441 W Memorial Rd, Oklahoma City, OK 73114, USA",
      "poi_short_description": "Family-friendly venue offering bowling, laser tag and arcade games, along with pizza and burgers, plus a ropes course.",
      "poi_long_description": "People say this restaurant offers a variety of entertainment options, including bowling, arcade games, laser tag, and pool. They also highlight the fun atmosphere, suitable for families and groups, and the friendly and helpful staff.\n\nSome reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d2709-1ca4-70a3-9247-d2e11609e1b6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-1ca4-70a3-9247-d2e11609e1b6",
        "storage_key": "property/6767906449165602/019d2709-1ca4-70a3-9247-d2e11609e1b6.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "http://www.mainevent.com/locations/oklahoma/oklahoma-city",
      "poi_directions_map_url": "https://maps.google.com/?cid=10621058190493493742&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "main-event-oklahoma-city",
      "poi_latitude": "35.6102071",
      "poi_longitude": "-97.5381584",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 6 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 405-751-4900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d2709-53cd-71da-8ff7-2432d31310c2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-53cd-71da-8ff7-2432d31310c2",
        "storage_key": "property/6767906449165602/019d2709-53cd-71da-8ff7-2432d31310c2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJf8bkHxccsocR7ikexyaUZZM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_28e1a963-4256-49ca-97e6-a1a1b52c52b5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "source": "custom",
      "poi_name": "Texas Roadhouse",
      "poi_type": "Restaurants",
      "poi_address": "2100 W Memorial Rd, Oklahoma City, OK 73134, USA",
      "poi_short_description": "Lively chain steakhouse serving American fare with a Southwestern spin amid Texas-themed decor.",
      "poi_long_description": "People say this steakhouse serves excellent steaks, chicken fried steak, and rolls. They also highlight the generous portions, reasonable prices, and attentive service.\n\nSome reviews mention the atmosphere can be loud.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d2709-1d1d-705d-b572-8f09d45fb66c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-1d1d-705d-b572-8f09d45fb66c",
        "storage_key": "property/6767906449165602/019d2709-1d1d-705d-b572-8f09d45fb66c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.texasroadhouse.com/locations/oklahoma/oklahoma-city-north-memorial-rd?utm_source=listing&utm_medium=search",
      "poi_directions_map_url": "https://maps.google.com/?cid=3657567219942529703&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "texas-roadhouse",
      "poi_latitude": "35.6078943",
      "poi_longitude": "-97.5503319",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 405-755-7427",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d2709-53cd-71da-8ff7-2432d31310c2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-53cd-71da-8ff7-2432d31310c2",
        "storage_key": "property/6767906449165602/019d2709-53cd-71da-8ff7-2432d31310c2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJiYzghGscsocRp5rJBgJKwjI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_729a3b48-b0ef-4e20-bb1d-6e3a9a188381",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "source": "custom",
      "poi_name": "Clark Crew BBQ",
      "poi_type": "Restaurants",
      "poi_address": "3510 Northwest Expy, Oklahoma City, OK 73112, USA",
      "poi_short_description": "Laid-back restaurant firing pizzas in brick ovens & preparing generous burgers & sandwiches.",
      "poi_long_description": "People say this barbecue restaurant serves delicious brisket, ribs, and burnt ends, and they highlight the amazing sides, such as baked beans, mashed potatoes, and cornbread. They also like the fast service and friendly staff.\n\nSome reviews mention the drinks can be unbalanced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d2709-1cc2-762f-8070-905214cd7e75.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-1cc2-762f-8070-905214cd7e75",
        "storage_key": "property/6767906449165602/019d2709-1cc2-762f-8070-905214cd7e75.webp",
        "width": 599,
        "height": 596
      },
      "poi_business_url": "http://www.clarkcrewbbq.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3587788996052338906&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "clark-crew-bbq",
      "poi_latitude": "35.5323986",
      "poi_longitude": "-97.5816496",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 38 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 405-724-8888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d2709-53cd-71da-8ff7-2432d31310c2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-53cd-71da-8ff7-2432d31310c2",
        "storage_key": "property/6767906449165602/019d2709-53cd-71da-8ff7-2432d31310c2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJq6r6_-4asocR2kjBPhVjyjE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "custom_1e2a3f9a-1179-48d7-977e-40b81edd2ef8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "source": "custom",
      "poi_name": "Meddys",
      "poi_type": "Restaurants",
      "poi_address": "9404 N May Ave, Oklahoma City, OK 73120, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this Mediterranean restaurant serves fresh, delicious food, including flavorful hummus and succulent chicken. They highlight the generous portions, reasonable prices, and the casual, relaxed vibe with a beautiful patio. They also like the friendly, attentive staff and quick service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d2709-216e-722a-9a3a-95c29119e08c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-216e-722a-9a3a-95c29119e08c",
        "storage_key": "property/6767906449165602/019d2709-216e-722a-9a3a-95c29119e08c.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.meddys.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10733599644329479405&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "meddys",
      "poi_latitude": "35.56632889999999",
      "poi_longitude": "-97.5666625",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 405-546-1003",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d2709-53cd-71da-8ff7-2432d31310c2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-53cd-71da-8ff7-2432d31310c2",
        "storage_key": "property/6767906449165602/019d2709-53cd-71da-8ff7-2432d31310c2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJIS_1pD8bsocR7YyE6QFo9ZQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mediterranean_restaurant"
    },
    {
      "id": "custom_b3e2e1b5-eba7-4a47-b2cb-997822380a7d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "source": "custom",
      "poi_name": "Quail Springs Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "2501 W Memorial Rd, Oklahoma City, OK 73134, USA",
      "poi_short_description": "Sprawling shopping center containing retailers, restaurant options & a 24-screen movie theater.",
      "poi_long_description": "People say this shopping center offers a variety of stores, including clothing, shoes, and toys, as well as entertainment options like an arcade, movie theater, and aquarium. They also highlight the clean and safe environment, and the fun atmosphere for families.\n\nOther reviews mention the food court can be limited.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d2709-21bc-744a-ae32-ad2db4f9ff20.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-21bc-744a-ae32-ad2db4f9ff20",
        "storage_key": "property/6767906449165602/019d2709-21bc-744a-ae32-ad2db4f9ff20.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.quailspringsmall.com/en.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=254102542958583292&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "quail-springs-mall",
      "poi_latitude": "35.6130282",
      "poi_longitude": "-97.5584437",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 405-254-4979",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d2709-53b2-7681-8240-826afd0ec8fb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-53b2-7681-8240-826afd0ec8fb",
        "storage_key": "property/6767906449165602/019d2709-53b2-7681-8240-826afd0ec8fb.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJS_2JfGccsocR_N2RoerAhgM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_1c7fe1cd-8959-439a-8ad7-4f814cc60276",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "3040 NW 59th St, Oklahoma City, OK 73112, USA",
      "poi_short_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_long_description": "People say this home improvement store offers a solid selection of tools and gardening supplies. They also highlight the easy layout, organized store, and helpful staff.\n\nOther reviews mention the customer service can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d2709-2192-746b-8860-f1582fe4d5fc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-2192-746b-8860-f1582fe4d5fc",
        "storage_key": "property/6767906449165602/019d2709-2192-746b-8860-f1582fe4d5fc.webp",
        "width": 704,
        "height": 292
      },
      "poi_business_url": "https://www.homedepot.com/l/N-Oklahoma-City/OK/Oklahoma-City/73112/3902?emt=MSEN?emt=MSGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=8923094349114202389&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "35.5312716",
      "poi_longitude": "-97.5695585",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 48 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 405-843-5008",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d2709-53b2-7681-8240-826afd0ec8fb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-53b2-7681-8240-826afd0ec8fb",
        "storage_key": "property/6767906449165602/019d2709-53b2-7681-8240-826afd0ec8fb.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJGSHGIfYasocRFVk_sAgz1Xs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_3af09dff-067b-4a16-8dce-312eb94ccbc5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "source": "custom",
      "poi_name": "Lowe's Home Improvement",
      "poi_type": "Shopping & Retail",
      "poi_address": "2400 W Memorial Rd, Oklahoma City, OK 73134, USA",
      "poi_short_description": "Home improvement chain for appliances & gardening supplies, plus tools & hardware.",
      "poi_long_description": "People say this home improvement store offers a wide selection of supplies for DIY projects, including lumber, paint, and appliances. They also highlight the helpful staff and the clean, organized aisles.\n\nOther reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d2709-21a9-7748-9cdb-4c328437fd7b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-21a9-7748-9cdb-4c328437fd7b",
        "storage_key": "property/6767906449165602/019d2709-21a9-7748-9cdb-4c328437fd7b.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.lowes.com/store/OK-Oklahoma-City/0535?cm_mmc=lod-_-c-_-lcl-_-awr-_-yxt-_-go-_-535-_-na-_-0-_-0&y_source=1_MTE4MzI1OC03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=9854502234558219169&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lowes-home-improvement",
      "poi_latitude": "35.606458",
      "poi_longitude": "-97.556346",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 405-936-2060",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d2709-53b2-7681-8240-826afd0ec8fb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-53b2-7681-8240-826afd0ec8fb",
        "storage_key": "property/6767906449165602/019d2709-53b2-7681-8240-826afd0ec8fb.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ80ErRm8csocRocMiKZI5wog",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_c86a60db-c178-45f1-abd5-0861d4db28aa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "source": "custom",
      "poi_name": "Barnes & Noble",
      "poi_type": "Shopping & Retail",
      "poi_address": "6100 N May Ave, Oklahoma City, OK 73112, USA",
      "poi_short_description": "Bookseller chain stocking housebrand eReader, plus a broad selection of titles for adults & kids.",
      "poi_long_description": "People say this bookstore offers a wide selection of books, magazines, and other items, including manga, games, and gifts. They highlight the clean, organized, and spacious layout, and the helpful and friendly staff. They also like the convenient location and the presence of a Starbucks cafe.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d2709-263e-750e-8494-ce9e51c7b8db.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-263e-750e-8494-ce9e51c7b8db",
        "storage_key": "property/6767906449165602/019d2709-263e-750e-8494-ce9e51c7b8db.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://stores.barnesandnoble.com/store/2694",
      "poi_directions_map_url": "https://maps.google.com/?cid=986591179468385464&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "barnes--noble",
      "poi_latitude": "35.5331139",
      "poi_longitude": "-97.5647667",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 46 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 405-843-9300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d2709-53b2-7681-8240-826afd0ec8fb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-53b2-7681-8240-826afd0ec8fb",
        "storage_key": "property/6767906449165602/019d2709-53b2-7681-8240-826afd0ec8fb.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJvczS4lgasocRuCy_VnMTsQ0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "book_store"
    },
    {
      "id": "custom_ae0b55ec-0bf2-447b-bb30-73cb7a15f352",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "source": "custom",
      "poi_name": "Sprouts Farmers Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "6410 N May Ave, Oklahoma City, OK 73116, USA",
      "poi_short_description": "Specialty chain offering a range of natural & organic grocery items, including own-brand goods.",
      "poi_long_description": "People say this grocery store offers a wide variety of organic, non-GMO, and healthy food, drinks, supplements, and bath and body products, as well as fresh produce, meat, and seafood. They also highlight the reasonable prices, good deals on bulk items and fruit, and the clean, well-stocked shelves.\n\nOther reviews mention the service can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d2709-2662-71af-9886-be5e9e6f6c80.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-2662-71af-9886-be5e9e6f6c80",
        "storage_key": "property/6767906449165602/019d2709-2662-71af-9886-be5e9e6f6c80.webp",
        "width": 958,
        "height": 1280
      },
      "poi_business_url": "https://sprouts.com/store/ok/oklahoma-city/oklahoma-city",
      "poi_directions_map_url": "https://maps.google.com/?cid=15265666738450826751&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sprouts-farmers-market",
      "poi_latitude": "35.5374999",
      "poi_longitude": "-97.5647576",
      "poi_miles_from_property": "7.1",
      "poi_walking_minutes": "2 hours 38 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 405-879-9989",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d2709-53d7-741a-a1a6-3bf355486504.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-53d7-741a-a1a6-3bf355486504",
        "storage_key": "property/6767906449165602/019d2709-53d7-741a-a1a6-3bf355486504.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJMSbEc1casocR_4XbhASL2tM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_1a579767-6d4e-4883-922e-440a398efabb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "source": "custom",
      "poi_name": "Southern Nazarene University",
      "poi_type": "Education",
      "poi_address": "6729 NW 39th Expy, Bethany, OK 73008, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d2709-26fb-7419-bd00-b36e52cf9305.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-26fb-7419-bd00-b36e52cf9305",
        "storage_key": "property/6767906449165602/019d2709-26fb-7419-bd00-b36e52cf9305.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.snu.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2990625230431240297&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "southern-nazarene-university",
      "poi_latitude": "35.5135594",
      "poi_longitude": "-97.6288124",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 31 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 405-789-6400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d2709-53aa-73c0-9064-bf92d7a78835.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-53aa-73c0-9064-bf92d7a78835",
        "storage_key": "property/6767906449165602/019d2709-53aa-73c0-9064-bf92d7a78835.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJHYsS70IFsocRacAsVM3VgCk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_9909aba9-7f97-4fc8-a071-53674a5bc02f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "source": "custom",
      "poi_name": "Belle Isle Library - Metropolitan Library System",
      "poi_type": "Education",
      "poi_address": "5501 N Villa Ave, Oklahoma City, OK 73112, USA",
      "poi_short_description": "Warm, friendly public library with a children’s area, study rooms and computers.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d2709-2667-716b-b752-7823236731b1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-2667-716b-b752-7823236731b1",
        "storage_key": "property/6767906449165602/019d2709-2667-716b-b752-7823236731b1.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.metrolibrary.org/?utm_source=GMBlisting&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=12135984821329026772&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "belle-isle-library---metropolitan-library-system",
      "poi_latitude": "35.52557300000001",
      "poi_longitude": "-97.5569692",
      "poi_miles_from_property": "8.1",
      "poi_walking_minutes": "3 hours 3 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 405-843-9601",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d2709-53aa-73c0-9064-bf92d7a78835.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-53aa-73c0-9064-bf92d7a78835",
        "storage_key": "property/6767906449165602/019d2709-53aa-73c0-9064-bf92d7a78835.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJWXwrG2gasocR1F7ZUuWta6g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_55d6e3ca-0ba6-421c-83ff-f6c505f40b01",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "source": "custom",
      "poi_name": "Patience S. Latting Northwest Library - Metropolitan Library System",
      "poi_type": "Education",
      "poi_address": "5600 NW 122nd St, Oklahoma City, OK 73142, USA",
      "poi_short_description": "Modern, welcoming library featuring kid-friendly activities and patios, plus a large selection of books.",
      "poi_long_description": "People say this public library offers a wide selection of books, comics, movies, and CDs, as well as meeting rooms and study spaces. They highlight the spacious, clean, and modern environment, and the relaxing and calming vibe. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d2709-2b8d-7249-9a5c-e3722676323e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-2b8d-7249-9a5c-e3722676323e",
        "storage_key": "property/6767906449165602/019d2709-2b8d-7249-9a5c-e3722676323e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.metrolibrary.org/?utm_source=GMBlisting&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=6566230327670178026&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "patience-s-latting-northwest-library---metropolitan-library-system",
      "poi_latitude": "35.5941759",
      "poi_longitude": "-97.6179217",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 405-606-3580",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d2709-53aa-73c0-9064-bf92d7a78835.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-53aa-73c0-9064-bf92d7a78835",
        "storage_key": "property/6767906449165602/019d2709-53aa-73c0-9064-bf92d7a78835.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJkacMZVEDsocR6oAtkrHvH1s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_9f07165e-f47c-44a2-9293-21f7c54c7191",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "source": "custom",
      "poi_name": "Blue Zoo Aquarium Oklahoma City",
      "poi_type": "Entertainment",
      "poi_address": "2501 W Memorial Rd Suite 125A, Oklahoma City, OK 73134, USA",
      "poi_short_description": "Mall-based attraction featuring sharks, stingrays, snakes and other marine life plus a playground for kids.",
      "poi_long_description": "People say this aquarium offers interactive experiences, including feeding stingrays, birds, and turtles, and petting stingrays. They also highlight the friendly and helpful staff, and the fun play areas for children.\n\nSome reviews mention the facility can be poorly maintained.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d2709-2ba8-774a-8868-b627c0300004.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-2ba8-774a-8868-b627c0300004",
        "storage_key": "property/6767906449165602/019d2709-2ba8-774a-8868-b627c0300004.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://oklahomacity.bluezoo.us/?utm_source=google&utm_medium=organic&utm_campaign=Google+Business+Profile+-+OKC",
      "poi_directions_map_url": "https://maps.google.com/?cid=5242468447430833348&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "blue-zoo-aquarium-oklahoma-city",
      "poi_latitude": "35.6125884",
      "poi_longitude": "-97.5573925",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 405-477-0222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d2709-5787-703c-9dae-995168743e5a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-5787-703c-9dae-995168743e5a",
        "storage_key": "property/6767906449165602/019d2709-5787-703c-9dae-995168743e5a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJy4zKmxcdsocRxPRO80b9wEg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "aquarium"
    },
    {
      "id": "custom_8e3482cb-3037-425c-b3c1-6c5dfe5a115e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "source": "custom",
      "poi_name": "SNU Football Stadium",
      "poi_type": "Entertainment",
      "poi_address": "Bethany, OK 73008, USA",
      "poi_short_description": "Stadium offering a field and a restroom.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d2709-2c57-77eb-a4c2-bf43bf36ed46.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-2c57-77eb-a4c2-bf43bf36ed46",
        "storage_key": "property/6767906449165602/019d2709-2c57-77eb-a4c2-bf43bf36ed46.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://snuathletics.com/facilities/snu-football-stadium/1",
      "poi_directions_map_url": "https://maps.google.com/?cid=14871021148287990153&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "snu-football-stadium",
      "poi_latitude": "35.5210831",
      "poi_longitude": "-97.661829",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 47 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d2709-584b-70cf-a29f-6c267153a49d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-584b-70cf-a29f-6c267153a49d",
        "storage_key": "property/6767906449165602/019d2709-584b-70cf-a29f-6c267153a49d.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJFyihiaEFsocRifkGv_F6YM4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_58746b1f-3a7e-42f6-82b6-fca73889e497",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "source": "custom",
      "poi_name": "Oklahoma Museum of Flying",
      "poi_type": "Entertainment",
      "poi_address": "7110 Millionaire Dr, Bethany, OK 73008, USA",
      "poi_short_description": "Volunteer-powered locale for seeing and touching real planes plus learning about their history and mechanics.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d2709-2d32-72fd-a58b-8cb595eba02e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-2d32-72fd-a58b-8cb595eba02e",
        "storage_key": "property/6767906449165602/019d2709-2d32-72fd-a58b-8cb595eba02e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.facebook.com/oklahomamuseumofflying/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7234880537762503548&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "oklahoma-museum-of-flying",
      "poi_latitude": "35.5334969",
      "poi_longitude": "-97.6380655",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 6 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d2709-576c-721f-8178-12691b23c9c1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-576c-721f-8178-12691b23c9c1",
        "storage_key": "property/6767906449165602/019d2709-576c-721f-8178-12691b23c9c1.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5c3VjhkFsocRfJu4XYR1Z2Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_b5c4faeb-c329-4700-81f6-72f50ab8af0c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "source": "custom",
      "poi_name": "Pirate Stadium",
      "poi_type": "Entertainment",
      "poi_address": "5300 NW 50th St, Oklahoma City, OK 73122, USA",
      "poi_short_description": "Venue used for graduation, track meets, and games.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d2709-308a-75cd-b0b1-970a413eee22.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-308a-75cd-b0b1-970a413eee22",
        "storage_key": "property/6767906449165602/019d2709-308a-75cd-b0b1-970a413eee22.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://stadiumconnection.com/ok/stadium.php?id=2852",
      "poi_directions_map_url": "https://maps.google.com/?cid=11523176646670315445&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "pirate-stadium",
      "poi_latitude": "35.5214547",
      "poi_longitude": "-97.6064145",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 405-789-7101",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d2709-584b-70cf-a29f-6c267153a49d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-584b-70cf-a29f-6c267153a49d",
        "storage_key": "property/6767906449165602/019d2709-584b-70cf-a29f-6c267153a49d.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJR1OWhrUasocRtW_clBuM6p8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_1904480b-fd0b-4992-9a91-7de8d4984566",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "source": "custom",
      "poi_name": "Herrick Building and Auditorium - SNU",
      "poi_type": "Entertainment",
      "poi_address": "6749 NW 39th Expy, Bethany, OK 73008, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d2709-3019-72ea-a514-63a528ab8dd3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-3019-72ea-a514-63a528ab8dd3",
        "storage_key": "property/6767906449165602/019d2709-3019-72ea-a514-63a528ab8dd3.webp",
        "width": 964,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=15681811452994641819&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "herrick-building-and-auditorium---snu",
      "poi_latitude": "35.5123354",
      "poi_longitude": "-97.6304674",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 36 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d2709-5787-703c-9dae-995168743e5a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-5787-703c-9dae-995168743e5a",
        "storage_key": "property/6767906449165602/019d2709-5787-703c-9dae-995168743e5a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4dCV-0IFsocRm99lQm78oNk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_ad266183-e401-425d-a085-013a0b56c70a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "source": "custom",
      "poi_name": "Life Time",
      "poi_type": "Health and Wellness",
      "poi_address": "2563 W Memorial Rd, Oklahoma City, OK 73134, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this gym offers a variety of services, including cardio/weights, group fitness, swimming, tennis, and pickleball. They also highlight the attentive lifeguards, the well-maintained facilities, and the excellent childcare program.\n\nSome reviews mention the equipment can be broken.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d2709-314b-736f-bd66-f7ecb7f7e81f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-314b-736f-bd66-f7ecb7f7e81f",
        "storage_key": "property/6767906449165602/019d2709-314b-736f-bd66-f7ecb7f7e81f.webp",
        "width": 1088,
        "height": 1088
      },
      "poi_business_url": "https://www.lifetime.life/locations/ok/oklahoma-city.html?utm_source=google&utm_medium=local&utm_campaign=google-local-club",
      "poi_directions_map_url": "https://maps.google.com/?cid=13614994550085944548&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "life-time",
      "poi_latitude": "35.61423510000001",
      "poi_longitude": "-97.5602129",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 405-832-5200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d2709-5787-703c-9dae-995168743e5a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-5787-703c-9dae-995168743e5a",
        "storage_key": "property/6767906449165602/019d2709-5787-703c-9dae-995168743e5a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVWAnM3kdsocR5ITAcGgt8rw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_5c49bec0-3481-4fc1-9f2a-0793a4452c44",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "source": "custom",
      "poi_name": "Crunch Fitness - Oklahoma City",
      "poi_type": "Health and Wellness",
      "poi_address": "12508 N May Ave, Oklahoma City, OK 73120, USA",
      "poi_short_description": "Gym, part of a chain, offering yoga, cardio and weights rooms, and tanning beds.",
      "poi_long_description": "Some gym goers say this gym has a wide variety of equipment, including squat racks, free weights, and cardio machines, as well as great group classes and a sauna. \n\nOther reviews mention the gym can be crowded and the music can be loud.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d2709-3258-7770-939f-9ae517ad4311.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-3258-7770-939f-9ae517ad4311",
        "storage_key": "property/6767906449165602/019d2709-3258-7770-939f-9ae517ad4311.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.crunch.com/locations/quail-springs",
      "poi_directions_map_url": "https://maps.google.com/?cid=6097941148085874568&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crunch-fitness---oklahoma-city",
      "poi_latitude": "35.5969373",
      "poi_longitude": "-97.565988",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 405-497-8160",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d2709-5787-703c-9dae-995168743e5a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-5787-703c-9dae-995168743e5a",
        "storage_key": "property/6767906449165602/019d2709-5787-703c-9dae-995168743e5a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8Z8NgOkdsocRiG_leCo9oFQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_20c1679b-9288-45d1-9366-a2b79e201f31",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "source": "custom",
      "poi_name": "Crunch Fitness - OKC Northwest",
      "poi_type": "Health and Wellness",
      "poi_address": "8490 Northwest Expy, Oklahoma City, OK 73162, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this gym offers a wide variety of equipment, including free weights, weight machines, and cardio equipment, as well as amenities like tanning booths, hydro massage machines, and red light therapy. They also highlight the reasonable pricing, friendly staff, and clean facilities.\n\nSome reviews mention the gym can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d2709-3514-7369-af7b-585273706a74.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-3514-7369-af7b-585273706a74",
        "storage_key": "property/6767906449165602/019d2709-3514-7369-af7b-585273706a74.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.crunch.com/locations/okc-northwest",
      "poi_directions_map_url": "https://maps.google.com/?cid=6916258324870179385&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crunch-fitness---okc-northwest",
      "poi_latitude": "35.56632099999999",
      "poi_longitude": "-97.6628647",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 405-267-6282",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d2709-5787-703c-9dae-995168743e5a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-5787-703c-9dae-995168743e5a",
        "storage_key": "property/6767906449165602/019d2709-5787-703c-9dae-995168743e5a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQWtxzOQFsocROaq5dE18-18",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_5448a440-74f5-4810-8624-624dbe6df2bf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "source": "custom",
      "poi_name": "TB Fit Club | TB Golf | TB Recovery",
      "poi_type": "Health and Wellness",
      "poi_address": "3333 W Hefner Rd, Oklahoma City, OK 73120, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this gym offers a wide variety of new and modern equipment, including a golf simulator and expanded recovery options, and the staff are helpful and professional.\n\nOther reviews mention the facilities can be poorly maintained and the air conditioning can be inadequate.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d2709-35f0-73ba-86ec-baba174a3839.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-35f0-73ba-86ec-baba174a3839",
        "storage_key": "property/6767906449165602/019d2709-35f0-73ba-86ec-baba174a3839.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://tbfitclub.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12558554567901756546&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tb-fit-club--tb-golf--tb-recovery",
      "poi_latitude": "35.5816564",
      "poi_longitude": "-97.5782735",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 405-849-9173",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d2709-5787-703c-9dae-995168743e5a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-5787-703c-9dae-995168743e5a",
        "storage_key": "property/6767906449165602/019d2709-5787-703c-9dae-995168743e5a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJSfqhdqYbsocRgrwkaNfySK4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_381dcd50-66ae-4ff6-a670-fa6acf975435",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "source": "custom",
      "poi_name": "Scissors & Scotch",
      "poi_type": "Health and Wellness",
      "poi_address": "13230 Pawnee Dr #202, Oklahoma City, OK 73114, USA",
      "poi_short_description": "Upscale barber shop for beard trims and straight-razor shaves alongside a private lounge and a full bar with whisky. Waxing, manicures and massages are also offered.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d2709-3677-7708-8ea1-d3882b505de1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-3677-7708-8ea1-d3882b505de1",
        "storage_key": "property/6767906449165602/019d2709-3677-7708-8ea1-d3882b505de1.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "http://scissorsscotch.com/locations/ok/oklahoma-city/chisholm-creek/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17460232672315201299&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "scissors--scotch",
      "poi_latitude": "35.60419",
      "poi_longitude": "-97.5337642",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 12 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 405-486-4902",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d2709-5787-703c-9dae-995168743e5a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-5787-703c-9dae-995168743e5a",
        "storage_key": "property/6767906449165602/019d2709-5787-703c-9dae-995168743e5a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ62z3xRocsocRE1cEcRs1T_I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barber_shop"
    },
    {
      "id": "custom_30d0c9e4-f837-435b-b660-ba08362cabd2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "source": "custom",
      "poi_name": "Four Star Fitness - Oklahoma City",
      "poi_type": "Health and Wellness",
      "poi_address": "7013 N May Ave, Oklahoma City, OK 73116, USA",
      "poi_short_description": "Spacious gym featuring weights and cardio equipment, plus personal training.",
      "poi_long_description": "People say this gym offers a wide variety of equipment. They highlight the serious and respectful workout environment. They also like the professional and friendly staff. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d2709-375b-7361-a5a8-2ab3bd68b53b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-375b-7361-a5a8-2ab3bd68b53b",
        "storage_key": "property/6767906449165602/019d2709-375b-7361-a5a8-2ab3bd68b53b.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.fourstarfitnessokc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17050931711802974728&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "four-star-fitness---oklahoma-city",
      "poi_latitude": "35.54217879999999",
      "poi_longitude": "-97.5664473",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 31 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 405-418-4496",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d2709-5787-703c-9dae-995168743e5a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-5787-703c-9dae-995168743e5a",
        "storage_key": "property/6767906449165602/019d2709-5787-703c-9dae-995168743e5a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJK6JthFYasocRCKJ1Ww0Uoew",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_5a2b6eef-9b36-4e6e-82f5-a35bac4d0881",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "10908 N May Ave A, Oklahoma City, OK 73120, USA",
      "poi_short_description": "Spacious gym with a hydro-massage area and tanning beds, plus classes and machines.",
      "poi_long_description": "People say this gym offers a variety of workout equipment and is clean. They also highlight the friendly and helpful staff, and the convenient hours.\n\nOther reviews mention the equipment can be removed.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d2709-3a3f-75dd-b424-396316640760.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-3a3f-75dd-b424-396316640760",
        "storage_key": "property/6767906449165602/019d2709-3a3f-75dd-b424-396316640760.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/oklahoma-city-quail-plaza-ok?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=3477844169655460775&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "35.5807984",
      "poi_longitude": "-97.5653315",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 405-697-1750",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d2709-5787-703c-9dae-995168743e5a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-5787-703c-9dae-995168743e5a",
        "storage_key": "property/6767906449165602/019d2709-5787-703c-9dae-995168743e5a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJeXhK4IIbsocRpyN6jNjIQzA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_8b2991e6-3a7f-4fb8-bc90-b61ae4d0fd90",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "source": "custom",
      "poi_name": "Rockwell Plaza YMCA",
      "poi_type": "Health and Wellness",
      "poi_address": "8300 Glade Ave, Oklahoma City, OK 73132, USA",
      "poi_short_description": "Clean gym with a basketball court.",
      "poi_long_description": "People say this gym offers a wide variety of equipment, including open weights, and has a spacious workout area and basketball gym.\n\nOther reviews mention the facilities can be poorly maintained and the staff can be unhelpful.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d2709-3b30-70ac-bb25-f2e13f26f510.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-3b30-70ac-bb25-f2e13f26f510",
        "storage_key": "property/6767906449165602/019d2709-3b30-70ac-bb25-f2e13f26f510.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://ymcaokc.org/branches/rockwell-plaza/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17719347020841965419&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "rockwell-plaza-ymca",
      "poi_latitude": "35.5546582",
      "poi_longitude": "-97.6422942",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 405-621-5858",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d2709-5787-703c-9dae-995168743e5a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-5787-703c-9dae-995168743e5a",
        "storage_key": "property/6767906449165602/019d2709-5787-703c-9dae-995168743e5a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJleKdJ_AEsocRa1cp_TvE5_U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_eb487d19-1cda-48d8-ba1e-f6132885e42b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "source": "custom",
      "poi_name": "10GYM",
      "poi_type": "Health and Wellness",
      "poi_address": "6209 Northwest Expy, Oklahoma City, OK 73132, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this gym offers a wide selection of equipment and personalized workout schedules. They highlight the motivating and supportive atmosphere, and the knowledgeable and skilled trainers. They also like the friendly and welcoming staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d2709-3ac4-71b8-bb74-5ca6fd5a7481.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-3ac4-71b8-bb74-5ca6fd5a7481",
        "storage_key": "property/6767906449165602/019d2709-3ac4-71b8-bb74-5ca6fd5a7481.webp",
        "width": 606,
        "height": 341
      },
      "poi_business_url": "https://10gym.com/no-oklahoma-city/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4245080577524329760&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "10gym",
      "poi_latitude": "35.5537007",
      "poi_longitude": "-97.6255295",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 405-728-3600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d2709-5787-703c-9dae-995168743e5a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-5787-703c-9dae-995168743e5a",
        "storage_key": "property/6767906449165602/019d2709-5787-703c-9dae-995168743e5a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2Th3F9sEsocRIG0_OkuO6To",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_aac4f5e7-60de-40e6-b783-66e765b2fc69",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "source": "custom",
      "poi_name": "INTEGRIS Health Baptist Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "3300 Northwest Expy, Oklahoma City, OK 73112, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d2709-3d64-71f6-b5b8-bc80be52a415.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-3d64-71f6-b5b8-bc80be52a415",
        "storage_key": "property/6767906449165602/019d2709-3d64-71f6-b5b8-bc80be52a415.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://baptist.integrishealth.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10369483754313068495&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "integris-health-baptist-medical-center",
      "poi_latitude": "35.5290386",
      "poi_longitude": "-97.5764421",
      "poi_miles_from_property": "7.1",
      "poi_walking_minutes": "2 hours 42 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 405-949-3011",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d2709-57b6-71f7-828f-5cd64e152590.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-57b6-71f7-828f-5cd64e152590",
        "storage_key": "property/6767906449165602/019d2709-57b6-71f7-828f-5cd64e152590.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJLX5SM_IasocRz68D4IjO548",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "custom_e7cb45fc-77c4-4ba1-b3f8-ae436745f9a1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "source": "custom",
      "poi_name": "Mercy Hospital Oklahoma City",
      "poi_type": "Health and Wellness",
      "poi_address": "4300 W Memorial Rd, Oklahoma City, OK 73120, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d2709-3fa7-71e9-a588-62bf856b3c84.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-3fa7-71e9-a588-62bf856b3c84",
        "storage_key": "property/6767906449165602/019d2709-3fa7-71e9-a588-62bf856b3c84.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.mercy.net/practice/mercy-hospital-oklahoma-city?utm_source=google&utm_medium=organic_search&utm_campaign=yext&utm_term=West&utm_content=website&y_source=1_MTI5OTY2MDItNzE1LWxvY2F0aW9uLndlYnNpdGU=",
      "poi_directions_map_url": "https://maps.google.com/?cid=9313836111055257082&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mercy-hospital-oklahoma-city",
      "poi_latitude": "35.607198",
      "poi_longitude": "-97.600529",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 405-755-1515",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d2709-57b6-71f7-828f-5cd64e152590.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-57b6-71f7-828f-5cd64e152590",
        "storage_key": "property/6767906449165602/019d2709-57b6-71f7-828f-5cd64e152590.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJE-YSHLkcsocR-n2nn5hkQYE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_a9b3b07a-fcf6-4b22-905d-42e38fe3860d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "source": "custom",
      "poi_name": "Martin Park Nature Center",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5000 W Memorial Rd, Oklahoma City, OK 73142, USA",
      "poi_short_description": "Park with trails through woods & grassland, plus amenities including a playground & nature center.",
      "poi_long_description": "People say this park offers beautiful walking trails, a playground, and opportunities to see wildlife like deer, turtles, and birds. They highlight the peaceful and serene atmosphere, and the well-maintained trails suitable for light hikes. They also like the friendly and knowledgeable staff at the visitor center.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d2709-3ffc-755f-959c-7c814f5a8b6c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-3ffc-755f-959c-7c814f5a8b6c",
        "storage_key": "property/6767906449165602/019d2709-3ffc-755f-959c-7c814f5a8b6c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.okc.gov/departments/parks-recreation/martin-park-nature-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=9715724291787303274&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "martin-park-nature-center",
      "poi_latitude": "35.6090059",
      "poi_longitude": "-97.6090052",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 405-297-1429",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d2709-5ba0-722f-8475-9741c68060d4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-5ba0-722f-8475-9741c68060d4",
        "storage_key": "property/6767906449165602/019d2709-5ba0-722f-8475-9741c68060d4.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ71CwarQcsocRaqmda8Qv1YY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_a6dd0cb2-9b92-4323-8295-bcf8926e5efe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "source": "custom",
      "poi_name": "Stars And Stripes Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3701 S Lake Hefner Dr, Oklahoma City, OK 73116, USA",
      "poi_short_description": "This park with a lake boasts a patriotic-themed playground plus baseball fields & a trail.",
      "poi_long_description": "People say this city park offers beautiful scenery, walking trails, a large playground, and panoramic views of the lake. They highlight the park's welcoming and well-kept atmosphere, making it a great place to relax, walk, or enjoy the outdoors. They also like the vibrant energy and family-friendly vibe, and appreciate the police presence for safety.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d2709-4056-7419-b9f7-b8c22296c346.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-4056-7419-b9f7-b8c22296c346",
        "storage_key": "property/6767906449165602/019d2709-4056-7419-b9f7-b8c22296c346.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.okc.gov/Home/Components/FacilityDirectory/FacilityDirectory/34/2846",
      "poi_directions_map_url": "https://maps.google.com/?cid=16012526237037472583&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "stars-and-stripes-park",
      "poi_latitude": "35.5500436",
      "poi_longitude": "-97.5822759",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 21 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 405-297-2756",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d2709-5ba0-722f-8475-9741c68060d4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-5ba0-722f-8475-9741c68060d4",
        "storage_key": "property/6767906449165602/019d2709-5ba0-722f-8475-9741c68060d4.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJo2tmaBwbsocRR6s9S8brN94",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_44ce81bd-ebb9-4931-b621-9cc66a9f86ae",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "source": "custom",
      "poi_name": "Bluff Creek Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "11301 N Meridian Ave, Oklahoma City, OK 73120, USA",
      "poi_short_description": "Dirt & paved hiking & biking trails wind through a wooded glen, with 3 covered picnic pavilions.",
      "poi_long_description": "Visitors say this park offers well-maintained walking, jogging, and biking trails, with opportunities to see wildlife like deer. They also highlight the peaceful atmosphere, ideal for enjoying nature and escaping the everyday hustle and bustle.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d2709-4307-769f-98cc-104f957ab999.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-4307-769f-98cc-104f957ab999",
        "storage_key": "property/6767906449165602/019d2709-4307-769f-98cc-104f957ab999.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.okc.gov/Home/Components/FacilityDirectory/FacilityDirectory/8/2846",
      "poi_directions_map_url": "https://maps.google.com/?cid=1559565554729670411&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bluff-creek-park",
      "poi_latitude": "35.584442",
      "poi_longitude": "-97.6065873",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 405-837-7995",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d2709-5ba0-722f-8475-9741c68060d4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-5ba0-722f-8475-9741c68060d4",
        "storage_key": "property/6767906449165602/019d2709-5ba0-722f-8475-9741c68060d4.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJh3zaRlYbsocRC9eY7ZuwpBU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_c0025d17-d658-40ee-a760-427895d1efb9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "source": "custom",
      "poi_name": "Rose Creek Country Club",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "17031 N May Ave, Edmond, OK 73012, USA",
      "poi_short_description": "Private golf course with an on-site eatery, pickleball courts, a clubhouse and a patio.",
      "poi_long_description": "People say this private golf course offers a great golf course, restaurants, and facilities. They also highlight the amazing staff, beautiful scenery, and good vibes.\n\nOther reviews mention the course conditions can be unchanged.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d2709-44aa-763a-be64-2d8a79f8c63c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-44aa-763a-be64-2d8a79f8c63c",
        "storage_key": "property/6767906449165602/019d2709-44aa-763a-be64-2d8a79f8c63c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.rosecreekgc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14897560691660009268&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "rose-creek-country-club",
      "poi_latitude": "35.6449907",
      "poi_longitude": "-97.5686808",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 16 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 405-330-8220",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d2709-5b62-73c6-acd0-36ef35320e98.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-5b62-73c6-acd0-36ef35320e98",
        "storage_key": "property/6767906449165602/019d2709-5b62-73c6-acd0-36ef35320e98.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJh8IOAwgdsocRNK83toTEvs4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_db1b9ea4-04b4-4996-aca8-21a608749ccd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "source": "custom",
      "poi_name": "Dolese Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5105 NW 50th St, Oklahoma City, OK 73112, USA",
      "poi_short_description": "A disc-golf course, baseball fields & walking trails are available at this municipal park.",
      "poi_long_description": "People say this park offers disc golf, baseball fields, a playground, a pond for fishing, and a tree-shaded area for ball games. They highlight the peaceful and tranquil vibe, and the clean and well-maintained facilities. They also like the walking trails and the opportunity to relax and enjoy the water view.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d2709-4564-7075-88e0-7d740728d746.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-4564-7075-88e0-7d740728d746",
        "storage_key": "property/6767906449165602/019d2709-4564-7075-88e0-7d740728d746.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.okc.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15736370327146326173&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "dolese-park",
      "poi_latitude": "35.52624369999999",
      "poi_longitude": "-97.6055628",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 37 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 405-297-2756",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d2709-5ba0-722f-8475-9741c68060d4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-5ba0-722f-8475-9741c68060d4",
        "storage_key": "property/6767906449165602/019d2709-5ba0-722f-8475-9741c68060d4.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJcf9-e8kasocRneiNC3DRYto",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_ba443d96-78ee-4900-97e5-062666c5dbbe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "source": "custom",
      "poi_name": "Wiley Post Airport-PWA",
      "poi_type": "Transportation & Transit",
      "poi_address": "5915 Philip J Rhoads Ave, Bethany, OK 73008, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d2709-4584-7578-b517-2fe0a62e42b5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-4584-7578-b517-2fe0a62e42b5",
        "storage_key": "property/6767906449165602/019d2709-4584-7578-b517-2fe0a62e42b5.webp",
        "width": 1280,
        "height": 1013
      },
      "poi_business_url": "http://www.wileypostairport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17919166834402155680&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "wiley-post-airport-pwa",
      "poi_latitude": "35.5307445",
      "poi_longitude": "-97.6430208",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 16 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 405-316-4061",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d2709-5bb3-77bd-98fd-af5e04f612b5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-5bb3-77bd-98fd-af5e04f612b5",
        "storage_key": "property/6767906449165602/019d2709-5bb3-77bd-98fd-af5e04f612b5.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_0-vGAMFsocRoFyAy0urrfg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_0c7bbc07-2c8e-4153-b74c-83112712748d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "source": "custom",
      "poi_name": "Sundance Airport KHSD",
      "poi_type": "Transportation & Transit",
      "poi_address": "13000 N Sara Rd, Yukon, OK 73099, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d2709-47a9-713c-a9b4-a20b93629424.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-47a9-713c-a9b4-a20b93629424",
        "storage_key": "property/6767906449165602/019d2709-47a9-713c-a9b4-a20b93629424.webp",
        "width": 1280,
        "height": 478
      },
      "poi_business_url": "http://sundanceairport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1335938299321620831&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sundance-airport-khsd",
      "poi_latitude": "35.601503",
      "poi_longitude": "-97.7069306",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 11 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 405-373-3886",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d2709-5bb3-77bd-98fd-af5e04f612b5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-5bb3-77bd-98fd-af5e04f612b5",
        "storage_key": "property/6767906449165602/019d2709-5bb3-77bd-98fd-af5e04f612b5.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6eH4NUUBsocRX5nnHM40ihI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_f3c439e6-d679-4599-b4c4-698c810dd480",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "source": "custom",
      "poi_name": "Jetset FBO",
      "poi_type": "Transportation & Transit",
      "poi_address": "7220 NW 63rd St, Bethany, OK 73008, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d2709-4958-770e-b9a0-86b66ac94a99.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-4958-770e-b9a0-86b66ac94a99",
        "storage_key": "property/6767906449165602/019d2709-4958-770e-b9a0-86b66ac94a99.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.jetsetfbo.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=522519284200811341&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "jetset-fbo",
      "poi_latitude": "35.5368188",
      "poi_longitude": "-97.6412624",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 4 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 405-888-8684",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d2709-5bb3-77bd-98fd-af5e04f612b5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-5bb3-77bd-98fd-af5e04f612b5",
        "storage_key": "property/6767906449165602/019d2709-5bb3-77bd-98fd-af5e04f612b5.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJm1b0wrcFsocRTasUQ4VcQAc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_7c577ed4-88b3-4c0c-8025-e745588b602d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "source": "custom",
      "poi_name": "Costco Member Service Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "14501 Bogert Pkwy, Oklahoma City, OK 73134, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d2709-4a61-7420-87d4-11e1f83ac959.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-4a61-7420-87d4-11e1f83ac959",
        "storage_key": "property/6767906449165602/019d2709-4a61-7420-87d4-11e1f83ac959.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.costco.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3497496067160567460&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "costco-member-service-center",
      "poi_latitude": "35.6183037",
      "poi_longitude": "-97.5748651",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d2709-5787-703c-9dae-995168743e5a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-5787-703c-9dae-995168743e5a",
        "storage_key": "property/6767906449165602/019d2709-5787-703c-9dae-995168743e5a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJX18i7nkdsocRpG5ufiSaiTA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_4c245494-76f6-4166-a32f-291dcbdda81c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "source": "custom",
      "poi_name": "Love's Corporate Office Building South",
      "poi_type": "Major Employers & Offices",
      "poi_address": "10401 N Pennsylvania Ave, The Village, OK 73120, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d2709-4c21-70ba-a194-22b328050087.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-4c21-70ba-a194-22b328050087",
        "storage_key": "property/6767906449165602/019d2709-4c21-70ba-a194-22b328050087.webp",
        "width": 1280,
        "height": 881
      },
      "poi_business_url": "http://www.loves.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14437476488466279899&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "loves-corporate-office-building-south",
      "poi_latitude": "35.5768571",
      "poi_longitude": "-97.5501262",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 58 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d2709-5787-703c-9dae-995168743e5a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-5787-703c-9dae-995168743e5a",
        "storage_key": "property/6767906449165602/019d2709-5787-703c-9dae-995168743e5a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJI5qho4IbsocR2y0WjF84XMg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_d48904a0-1ce4-4b4d-82c9-3a52037994ad",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "source": "custom",
      "poi_name": "Love's South Building",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2101 Vineyard Blvd, Oklahoma City, OK 73120, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d2709-4c4a-74fb-bac7-d7b4deccff16.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-4c4a-74fb-bac7-d7b4deccff16",
        "storage_key": "property/6767906449165602/019d2709-4c4a-74fb-bac7-d7b4deccff16.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.loves.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4360911662846330364&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "loves-south-building",
      "poi_latitude": "35.5769306",
      "poi_longitude": "-97.5501889",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 58 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 800-655-6837",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d2709-5787-703c-9dae-995168743e5a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-5787-703c-9dae-995168743e5a",
        "storage_key": "property/6767906449165602/019d2709-5787-703c-9dae-995168743e5a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJTfjgpJsbsocR_EXQYA0ShTw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_a222a456-e5fe-4c38-be3d-b50a78e856c2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "source": "custom",
      "poi_name": "Express Employment International",
      "poi_type": "Major Employers & Offices",
      "poi_address": "9701 Boardwalk Blvd, Oklahoma City, OK 73162, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d2709-4ee0-7159-b793-9e5a7edc3023.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-4ee0-7159-b793-9e5a7edc3023",
        "storage_key": "property/6767906449165602/019d2709-4ee0-7159-b793-9e5a7edc3023.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.expresspros.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=92586903052956857&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "express-employment-international",
      "poi_latitude": "35.56707",
      "poi_longitude": "-97.666693",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 405-840-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d2709-5787-703c-9dae-995168743e5a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-5787-703c-9dae-995168743e5a",
        "storage_key": "property/6767906449165602/019d2709-5787-703c-9dae-995168743e5a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJr6z8UW8EsocRuTRTO0zvSAE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_36fb1421-e495-41ed-8452-f74ef563136b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "source": "custom",
      "poi_name": "Love's Corporate - Building 50",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3601 NW 63rd St, Oklahoma City, OK 73116, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d2709-4f92-73ed-9d30-a30c6e22bb65.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-4f92-73ed-9d30-a30c6e22bb65",
        "storage_key": "property/6767906449165602/019d2709-4f92-73ed-9d30-a30c6e22bb65.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.loves.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4599439798442847940&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "loves-corporate---building-50",
      "poi_latitude": "35.5374849",
      "poi_longitude": "-97.5809021",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 29 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 800-655-6837",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d2709-5787-703c-9dae-995168743e5a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-5787-703c-9dae-995168743e5a",
        "storage_key": "property/6767906449165602/019d2709-5787-703c-9dae-995168743e5a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJw8bq4uQasocRxO76tyB-1D8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_2ed9dc83-2de3-481d-9fd8-34da38ed2359",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "source": "custom",
      "poi_name": "James L. Dennis Elementary",
      "poi_type": "Education",
      "poi_address": "11800 James L Dennis Dr, Oklahoma City, OK 73162, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://dennis.putnamcityschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11960917566250256721&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "james-l-dennis-elementary",
      "poi_latitude": "35.5889218",
      "poi_longitude": "-97.6308249",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 405-722-6510",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019cfb3f-8c09-7753-997b-16420c43ca01.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-8c09-7753-997b-16420c43ca01",
        "storage_key": "property/6767906449165602/019cfb3f-8c09-7753-997b-16420c43ca01.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJA_VMkl8DsocRUYkTpCe3_aU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_b6b73b76-de58-40a4-9869-4fb21cfa1676",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "source": "custom",
      "poi_name": "Hefner Middle School",
      "poi_type": "Education",
      "poi_address": "8400 N MacArthur Blvd, Oklahoma City, OK 73132, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d7912-2dda-766f-aff0-73f66e4761d9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-2dda-766f-aff0-73f66e4761d9",
        "storage_key": "property/6767906449165602/019d7912-2dda-766f-aff0-73f66e4761d9.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://hefner.putnamcityschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3061661222022488476&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "hefner-middle-school",
      "poi_latitude": "35.557427",
      "poi_longitude": "-97.6193703",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 405-721-2411",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019cfb3f-8c09-7753-997b-16420c43ca01.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-8c09-7753-997b-16420c43ca01",
        "storage_key": "property/6767906449165602/019cfb3f-8c09-7753-997b-16420c43ca01.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJsWfEvs8EsocRnCE9-ag0fSo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_2279d4cd-6849-42e8-8d97-f0b4540f8ec1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "source": "custom",
      "poi_name": "Dove Science Academy - High School OKC",
      "poi_type": "Education",
      "poi_address": "5601 Northwest Expy, Warr Acres, OK 73132, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d7912-2ddb-7486-95fa-66b618731769.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-2ddb-7486-95fa-66b618731769",
        "storage_key": "property/6767906449165602/019d7912-2ddb-7486-95fa-66b618731769.webp",
        "width": 640,
        "height": 480
      },
      "poi_business_url": "http://www.dsaokc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16553116476273055865&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "dove-science-academy-high-school-okc",
      "poi_latitude": "35.54825350000001",
      "poi_longitude": "-97.6132621",
      "poi_miles_from_property": "3.9 mi",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 405-524-9762",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019cfb3f-8c09-7753-997b-16420c43ca01.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-8c09-7753-997b-16420c43ca01",
        "storage_key": "property/6767906449165602/019cfb3f-8c09-7753-997b-16420c43ca01.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ4XznZbIQsocRedjrpbt7uOU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_8d8564e8-acc2-454e-8247-4f85333dbf8e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "source": "custom",
      "poi_name": "Putnam City North High School",
      "poi_type": "Education",
      "poi_address": "11800 N Rockwell Ave, Oklahoma City, OK 73162, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d7912-2cb4-704c-b75e-154e5b3cdb08.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-2cb4-704c-b75e-154e5b3cdb08",
        "storage_key": "property/6767906449165602/019d7912-2cb4-704c-b75e-154e5b3cdb08.webp",
        "width": 960,
        "height": 720
      },
      "poi_business_url": "https://pcnorth.putnamcityschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10895318835090211107&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "putnam-city-north-high-school",
      "poi_latitude": "35.5891349",
      "poi_longitude": "-97.6368418",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 405-722-4220",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019cfb3f-8c09-7753-997b-16420c43ca01.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-8c09-7753-997b-16420c43ca01",
        "storage_key": "property/6767906449165602/019cfb3f-8c09-7753-997b-16420c43ca01.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ-ZkjjmADsocRI8EsMMHyM5c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_01e4009d-ce8d-40ed-8058-82a5899302ff",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "source": "custom",
      "poi_name": "Oklahoma City University",
      "poi_type": "Education",
      "poi_address": "2501 N Blackwelder Ave, Oklahoma City, OK 73106, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d7912-2e06-75d7-9ee0-14f95e049348.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-2e06-75d7-9ee0-14f95e049348",
        "storage_key": "property/6767906449165602/019d7912-2e06-75d7-9ee0-14f95e049348.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.okcu.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=411899583880737593&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "oklahoma-city-university",
      "poi_latitude": "35.4954082",
      "poi_longitude": "-97.540768",
      "poi_miles_from_property": "10.9 mi",
      "poi_walking_minutes": "4 hours 7 mins",
      "poi_biking_minutes": "1 hour 8 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 405-208-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019cfb3f-8c09-7753-997b-16420c43ca01.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-8c09-7753-997b-16420c43ca01",
        "storage_key": "property/6767906449165602/019cfb3f-8c09-7753-997b-16420c43ca01.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJe7zZY6MQsocRObNXPH1ctwU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_2c077e6d-4f96-40fd-a686-0608ecaea352",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "source": "custom",
      "poi_name": "Central Oklahoma College",
      "poi_type": "Education",
      "poi_address": "14820 Serenita Ave, Oklahoma City, OK 73134, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d7912-3742-7059-b6fc-4087417f7d41.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-3742-7059-b6fc-4087417f7d41",
        "storage_key": "property/6767906449165602/019d7912-3742-7059-b6fc-4087417f7d41.webp",
        "width": 1280,
        "height": 758
      },
      "poi_business_url": "http://www.centraloc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17937297259247166320&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "central-oklahoma-college",
      "poi_latitude": "35.6214379",
      "poi_longitude": "-97.5602012",
      "poi_miles_from_property": "4.9 mi",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 405-609-6622",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019cfb3f-8c09-7753-997b-16420c43ca01.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-8c09-7753-997b-16420c43ca01",
        "storage_key": "property/6767906449165602/019cfb3f-8c09-7753-997b-16420c43ca01.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJvTWsrm8EsocRcOMDSNIU7vg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "educational_institution"
    },
    {
      "id": "custom_b66b6c8f-cde6-451a-8d7c-07ee763ee442",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "source": "custom",
      "poi_name": "Francis Tuttle Technology Center - Rockwell Campus",
      "poi_type": "Education",
      "poi_address": "12777 N Rockwell Ave, Oklahoma City, OK 73142, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d7912-3a3b-7459-b359-f19e733af991.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-3a3b-7459-b359-f19e733af991",
        "storage_key": "property/6767906449165602/019d7912-3a3b-7459-b359-f19e733af991.webp",
        "width": 960,
        "height": 720
      },
      "poi_business_url": "https://www.francistuttle.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6888824651484980707&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "francis-tuttle-technology-center-rockwell-campus",
      "poi_latitude": "35.6005273",
      "poi_longitude": "-97.63997",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 405-717-7799",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019cfb3f-8c09-7753-997b-16420c43ca01.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-8c09-7753-997b-16420c43ca01",
        "storage_key": "property/6767906449165602/019cfb3f-8c09-7753-997b-16420c43ca01.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ_XsrK2kDsocR42W3n4UFml8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "educational_institution"
    },
    {
      "id": "custom_ae8a3bde-7490-4a71-990b-4cac65dddd97",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "source": "custom",
      "poi_name": "Panera Bread",
      "poi_type": "Restaurants",
      "poi_address": "4225 W Memorial Rd Suite 500, Oklahoma City, OK 73134, USA",
      "poi_short_description": "Counter-serve bakery/cafe chain serving sandwiches, salads & more, known for its bread & free WiFi.",
      "poi_long_description": "People say this cafe offers delicious sandwiches, especially the tuna and turkey, and soft, chewy bagels. They also highlight the convenient ordering options, including walk-up cashier, automated devices, and app ordering, and the cozy atmosphere.\n\nOther reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d7912-3bd8-72d8-b54f-cfe1683eb2a3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-3bd8-72d8-b54f-cfe1683eb2a3",
        "storage_key": "property/6767906449165602/019d7912-3bd8-72d8-b54f-cfe1683eb2a3.webp",
        "width": 1280,
        "height": 985
      },
      "poi_business_url": "https://www.panerabread.com/en-us/cafe/locations/ok/oklahoma-city/4225-w-memorial-rd?utm_medium=local&utm_source=google&utm_campaign=dpm-dist&utm_term=202542&utm_content=main",
      "poi_directions_map_url": "https://maps.google.com/?cid=13907479482995088796&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "panera-bread",
      "poi_latitude": "35.6108246",
      "poi_longitude": "-97.597816",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 405-302-0500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d7912-96e4-7348-a3ac-fcc4a83108bf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d7912-96e4-7348-a3ac-fcc4a83108bf",
        "storage_key": "property/6767906449165602/019d7912-96e4-7348-a3ac-fcc4a83108bf.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJ4UcfH8gcsocRnJ30oOdKAcE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cafe"
    },
    {
      "id": "custom_616211ca-ac39-48db-86f4-05ae16709e69",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "source": "custom",
      "poi_name": "Charleston's Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "5608 W Memorial Rd, Oklahoma City, OK 73142, USA",
      "poi_short_description": "Relaxed hangout serving classic pub fare, such as burgers, ribs & tenders, plus wine & cocktails.",
      "poi_long_description": "People say this restaurant serves delicious entrees and desserts, including a popular coconut pie. They highlight the reasonable prices and quick service. They also like the friendly and attentive staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d7912-3be0-708f-9771-fcadb6eb0d4e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-3be0-708f-9771-fcadb6eb0d4e",
        "storage_key": "property/6767906449165602/019d7912-3be0-708f-9771-fcadb6eb0d4e.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "http://charlestons.com/locations/charlestons-okc-memorial/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17583160907117921524&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "charleston-s-restaurant",
      "poi_latitude": "35.608317",
      "poi_longitude": "-97.6174085",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 405-470-8169",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019cfb3f-8c1b-71e8-a5bb-4f3536b15525.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-8c1b-71e8-a5bb-4f3536b15525",
        "storage_key": "property/6767906449165602/019cfb3f-8c1b-71e8-a5bb-4f3536b15525.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJCTyr_UkDsocR9IRMea_vA_Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_a99fa377-10d5-44f3-857f-5c5e771621d2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "source": "custom",
      "poi_name": "Volcano Sushi Bar & Hibachi",
      "poi_type": "Restaurants",
      "poi_address": "5612 W Memorial Rd, Oklahoma City, OK 73142, USA",
      "poi_short_description": "Restaurant serving Japanese fare including sushi, hibachi meals, and sake, in a casual setting.",
      "poi_long_description": "People say this sushi restaurant offers delicious sushi and hibachi, with a special deal on select rolls on Tuesdays. They highlight the friendly staff and the generous portions, especially on the lunch menu. They also like the clean and inviting atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d7912-47b6-75aa-9409-29f7caa79d09.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-47b6-75aa-9409-29f7caa79d09",
        "storage_key": "property/6767906449165602/019d7912-47b6-75aa-9409-29f7caa79d09.webp",
        "width": 1280,
        "height": 576
      },
      "poi_business_url": "http://volcanook.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5542535958944007931&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "volcano-sushi-bar-hibachi",
      "poi_latitude": "35.6082332",
      "poi_longitude": "-97.6179352",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 405-603-2388",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019cfb3f-8c1b-71e8-a5bb-4f3536b15525.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-8c1b-71e8-a5bb-4f3536b15525",
        "storage_key": "property/6767906449165602/019cfb3f-8c1b-71e8-a5bb-4f3536b15525.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJXQyMjq4DsocR-8avyxYL60w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sushi_restaurant"
    },
    {
      "id": "custom_0d942491-cadb-4ba8-9cf0-e1f207f8a53c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "source": "custom",
      "poi_name": "Redrock Canyon Grill",
      "poi_type": "Restaurants",
      "poi_address": "9221 Lake Hefner Pkwy, Oklahoma City, OK 73120, USA",
      "poi_short_description": "Easygoing bistro & bar turning out wood-fired rotisserie chicken & Southwest-inspired dishes.",
      "poi_long_description": "People say this American restaurant serves delicious roasted chicken, filet, and ribs, and the house salad with cornbread croutons is a highlight. They highlight the beautiful lake views, especially at sunset, and the lively, upbeat atmosphere. They also like the attentive and friendly service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d7912-4718-75bd-b4b8-a4e9b8b152cb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-4718-75bd-b4b8-a4e9b8b152cb",
        "storage_key": "property/6767906449165602/019d7912-4718-75bd-b4b8-a4e9b8b152cb.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.redrockcanyongrill.com/locations/redrock-canyon-grill-okc/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18024707086159946252&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "redrock-canyon-grill",
      "poi_latitude": "35.5637167",
      "poi_longitude": "-97.5781056",
      "poi_miles_from_property": "4.8 mi",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 405-749-1995",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019cfb3f-8c1b-71e8-a5bb-4f3536b15525.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-8c1b-71e8-a5bb-4f3536b15525",
        "storage_key": "property/6767906449165602/019cfb3f-8c1b-71e8-a5bb-4f3536b15525.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_f3w5AsbsocRDKIHi5ifJPo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_5eec5d4d-e822-4ad7-ab8e-1732a1656f2e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "source": "custom",
      "poi_name": "The Garage Burgers & Beer",
      "poi_type": "Restaurants",
      "poi_address": "6900 NW 122nd St, Oklahoma City, OK 73142, USA",
      "poi_short_description": "Trendy bar with TV sports & games, known for inventive gourmet burgers, tacos & hot dogs.",
      "poi_long_description": "People say this hamburger restaurant serves delicious burgers, including bison burgers, and loaded queso. They also highlight the fun atmosphere, decent beer selection, and attentive staff.\n\nSome reviews mention the orders can be incorrect.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d7912-4950-76d8-90cb-e1ce19eb3a4c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-4950-76d8-90cb-e1ce19eb3a4c",
        "storage_key": "property/6767906449165602/019d7912-4950-76d8-90cb-e1ce19eb3a4c.webp",
        "width": 1000,
        "height": 667
      },
      "poi_business_url": "http://eatatthegarage.com/locations/the-garage-rockwell/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7470076178638343110&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-garage-burgers-beer",
      "poi_latitude": "35.5941438",
      "poi_longitude": "-97.6367409",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 405-603-3080",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019cfb3f-8c1b-71e8-a5bb-4f3536b15525.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-8c1b-71e8-a5bb-4f3536b15525",
        "storage_key": "property/6767906449165602/019cfb3f-8c1b-71e8-a5bb-4f3536b15525.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJZwMGVGYDsocRxovY0LQKq2c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "custom_13252b82-7cf4-4b86-b73c-056902b8aad1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "source": "custom",
      "poi_name": "Sunnyside Diner",
      "poi_type": "Restaurants",
      "poi_address": "9148 N MacArthur Blvd, Oklahoma City, OK 73132, USA",
      "poi_short_description": "Sunny, family-owned venue serving comfort food with vegan options, including popular cinnamon rolls.",
      "poi_long_description": "Diners say this diner serves up delicious cinnamon rolls, pancakes, and breakfast burritos, and they praise the friendly and attentive service. They also highlight the diner's reasonable prices and pleasant atmosphere.\n\nSome reviews mention the wait times can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d7912-4cea-778b-bb27-600a437fb981.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-4cea-778b-bb27-600a437fb981",
        "storage_key": "property/6767906449165602/019d7912-4cea-778b-bb27-600a437fb981.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "http://eatatsunnyside.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8360246992459314393&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "sunnyside-diner",
      "poi_latitude": "35.5638042",
      "poi_longitude": "-97.620361",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 405-722-8262",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019cfb3f-8c1b-71e8-a5bb-4f3536b15525.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-8c1b-71e8-a5bb-4f3536b15525",
        "storage_key": "property/6767906449165602/019cfb3f-8c1b-71e8-a5bb-4f3536b15525.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJjYhFRsgEsocR2bQQXFiQBXQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "diner"
    },
    {
      "id": "custom_ca9a8c03-5e22-40b1-81f9-58d87ceead60",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "source": "custom",
      "poi_name": "Revolve Pizza Kitchen",
      "poi_type": "Restaurants",
      "poi_address": "5500 W Memorial Rd, Oklahoma City, OK 73142, USA",
      "poi_short_description": "Casual eatery specializing in fresh pizza pies made to order.",
      "poi_long_description": "People say this pizza restaurant offers delicious pizza with plentiful toppings, and a variety of options for building your own pizza. They also highlight the friendly and accommodating staff, and the quick and fresh service.\n\nOther reviews mention the dining area can be unkempt.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d7912-5460-70f5-a68a-f7bf92d67332.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-5460-70f5-a68a-f7bf92d67332",
        "storage_key": "property/6767906449165602/019d7912-5460-70f5-a68a-f7bf92d67332.webp",
        "width": 800,
        "height": 800
      },
      "poi_business_url": "http://www.revolvepizza.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9800331040619987964&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "revolve-pizza-kitchen",
      "poi_latitude": "35.6085878",
      "poi_longitude": "-97.6153278",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 405-792-2858",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019cfb3f-8c1b-71e8-a5bb-4f3536b15525.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-8c1b-71e8-a5bb-4f3536b15525",
        "storage_key": "property/6767906449165602/019cfb3f-8c1b-71e8-a5bb-4f3536b15525.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJITl7CUoDsocR_INjNSjFAYg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_d2499d62-f664-4e6d-8529-fd3feddd0b68",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "source": "custom",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "8315 N Rockwell Ave, Oklahoma City, OK 73132, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "People say this department store offers a wide variety of products. They also highlight the competitive prices and helpful employees.\n\nOther reviews mention the pickup service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d7912-5461-71ba-97e7-c05fcd21e96a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-5461-71ba-97e7-c05fcd21e96a",
        "storage_key": "property/6767906449165602/019d7912-5461-71ba-97e7-c05fcd21e96a.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.target.com/sl/oklahoma-city-nw/1860",
      "poi_directions_map_url": "https://maps.google.com/?cid=2895961470460129515&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "target",
      "poi_latitude": "35.5554671",
      "poi_longitude": "-97.6397234",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 405-506-6086",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019cfb3f-8c0b-719b-8a30-1f72434dfd2c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-8c0b-719b-8a30-1f72434dfd2c",
        "storage_key": "property/6767906449165602/019cfb3f-8c0b-719b-8a30-1f72434dfd2c.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJL67v1OgEsocR63D-KZ2FMCg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_e9f09678-88b2-4203-8eb5-cde65a1762d9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "source": "custom",
      "poi_name": "H&M",
      "poi_type": "Shopping & Retail",
      "poi_address": "2501 W Memorial Rd Suite 149, Oklahoma City, OK 73134, USA",
      "poi_short_description": "Chain retailer supplying on-trend clothing, swimwear, accessories & shoes.",
      "poi_long_description": "Chain retailer supplying on-trend clothing, swimwear, accessories & shoes.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d7912-5a47-71e9-be8e-a31d41594661.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-5a47-71e9-be8e-a31d41594661",
        "storage_key": "property/6767906449165602/019d7912-5a47-71e9-be8e-a31d41594661.webp",
        "width": 1280,
        "height": 576
      },
      "poi_business_url": "https://www2.hm.com/en_us/customer-service/shopping-at-hm/store-locator/usa/oklahoma%20city/quail-springs-mall/US0425.html?utm_source=google_location&utm_medium=organic&utm_content=US0425&utm_campaign=pi_USQ00AAU0AA004",
      "poi_directions_map_url": "https://maps.google.com/?cid=16040804766410082988&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "h-m",
      "poi_latitude": "35.61334840000001",
      "poi_longitude": "-97.5584386",
      "poi_miles_from_property": "4.6 mi",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 855-466-7467",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019cfb3f-8c0b-719b-8a30-1f72434dfd2c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-8c0b-719b-8a30-1f72434dfd2c",
        "storage_key": "property/6767906449165602/019cfb3f-8c0b-719b-8a30-1f72434dfd2c.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ292aS10csocRrApEffJinN4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "clothing_store"
    },
    {
      "id": "custom_51c0c06c-7f98-4199-9dd1-ef94dfd28122",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "source": "custom",
      "poi_name": "PetSmart",
      "poi_type": "Shopping & Retail",
      "poi_address": "8357 N Rockwell Ave, Oklahoma City, OK 73132, USA",
      "poi_short_description": "Chain featuring a range of pets, supplies & food (most offer grooming, boarding & other services).",
      "poi_long_description": "People say this pet supply store offers a wide variety of products. They also highlight the friendly and helpful staff, and the clean store.\n\nOther reviews mention some items can be stocked on high shelves.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d7912-5fd1-75ac-9610-5324ae6bee16.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-5fd1-75ac-9610-5324ae6bee16",
        "storage_key": "property/6767906449165602/019d7912-5fd1-75ac-9610-5324ae6bee16.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.petsmart.com/stores/us/ok/oklahoma-city-store1516.html?utm_source=google&utm_medium=organic&utm_campaign=google-my-business",
      "poi_directions_map_url": "https://maps.google.com/?cid=16462577978014273428&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "petsmart",
      "poi_latitude": "35.555779",
      "poi_longitude": "-97.6415692",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 405-720-0104",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019cfb3f-8c0b-719b-8a30-1f72434dfd2c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-8c0b-719b-8a30-1f72434dfd2c",
        "storage_key": "property/6767906449165602/019cfb3f-8c0b-719b-8a30-1f72434dfd2c.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJdZcR1egEsocRlI-10nLTduQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_590d339f-7918-4085-8e43-7095db904f91",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "source": "custom",
      "poi_name": "Costco Wholesale",
      "poi_type": "Shopping & Retail",
      "poi_address": "13200 N Western Ave, Oklahoma City, OK 73114, USA",
      "poi_short_description": "Members-only warehouse selling a huge variety of items including bulk groceries, electronics & more.",
      "poi_long_description": "People say this warehouse store offers a wide variety of products, including fresh produce, easy-cook meals, and clothing. They also highlight the great deals, awesome prices, and the availability of unique items.\n\nOther reviews mention the checkout process can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d7912-6152-759f-b08a-7524270c3f5e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-6152-759f-b08a-7524270c3f5e",
        "storage_key": "property/6767906449165602/019d7912-6152-759f-b08a-7524270c3f5e.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "https://www.costco.com/warehouse-locations/oklahoma-city-OK-1350.html?utm_term=KW&utm_campaign=Homepage&utm_medium=GMB&utm_source=Google&utm_content=Link",
      "poi_directions_map_url": "https://maps.google.com/?cid=14122877494864452912&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "costco-wholesale",
      "poi_latitude": "35.6041749",
      "poi_longitude": "-97.5303089",
      "poi_miles_from_property": "6.1 mi",
      "poi_walking_minutes": "2 hours 15 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 405-832-5102",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019cfb3f-8c0b-719b-8a30-1f72434dfd2c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-8c0b-719b-8a30-1f72434dfd2c",
        "storage_key": "property/6767906449165602/019cfb3f-8c0b-719b-8a30-1f72434dfd2c.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJaye3fSUdsocRMB3BX0GK_sM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "warehouse_store"
    },
    {
      "id": "custom_3afa1d0c-a190-4202-92a2-558e34592226",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "source": "custom",
      "poi_name": "National Cowboy & Western Heritage Museum",
      "poi_type": "Entertainment",
      "poi_address": "1700 NE 63rd St, Oklahoma City, OK 73111, USA",
      "poi_short_description": "Dioramas, artifacts, art & more documenting & interpreting the history of the American West.",
      "poi_long_description": "People say this heritage museum offers a vast collection of Western art, artifacts, and historical exhibits, including sculptures, paintings, clothing, and personal items from historical figures. They highlight the educational and family-friendly atmosphere, with engaging multi-media displays, outdoor exhibits, and a playground. They also like the friendly and knowledgeable staff, and the informative presentations by docents. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d7912-6304-711f-a218-f308d0c98f1b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-6304-711f-a218-f308d0c98f1b",
        "storage_key": "property/6767906449165602/019d7912-6304-711f-a218-f308d0c98f1b.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "http://nationalcowboymuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4849781199640138445&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "national-cowboy-western-heritage-museum",
      "poi_latitude": "35.5356997",
      "poi_longitude": "-97.4831286",
      "poi_miles_from_property": "11.2 mi",
      "poi_walking_minutes": "4 hours 8 mins",
      "poi_biking_minutes": "1 hour 7 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 405-478-2250",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019cfb3f-8c17-723f-b514-c3e50ea5941a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-8c17-723f-b514-c3e50ea5941a",
        "storage_key": "property/6767906449165602/019cfb3f-8c17-723f-b514-c3e50ea5941a.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ-cenbQZsocRzRLrSk7iTUM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_f28b0efe-f16a-4d14-a2b1-5d7a3ce9409a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "source": "custom",
      "poi_name": "Science Museum Oklahoma",
      "poi_type": "Entertainment",
      "poi_address": "2020 Remington Pl, Oklahoma City, OK 73111, USA",
      "poi_short_description": "Expansive museum with child-friendly, hands-on exhibits, plus a planetarium & cafe.",
      "poi_long_description": "People say this science museum offers a wide variety of fun, interactive exhibits and activities, including a planetarium and a slanted room. They highlight the educational value, the engaging live shows, and the spacious layout that prevents overcrowding. They also like the friendly and knowledgeable staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d7912-6bf7-721e-aa66-e2f70977e4e1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-6bf7-721e-aa66-e2f70977e4e1",
        "storage_key": "property/6767906449165602/019d7912-6bf7-721e-aa66-e2f70977e4e1.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.sciencemuseumok.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11678503685854338412&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "science-museum-oklahoma",
      "poi_latitude": "35.5237553",
      "poi_longitude": "-97.4754913",
      "poi_miles_from_property": "12.1 mi",
      "poi_walking_minutes": "4 hours 28 mins",
      "poi_biking_minutes": "1 hour 12 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 405-602-6664",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019cfb3f-8c17-723f-b514-c3e50ea5941a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-8c17-723f-b514-c3e50ea5941a",
        "storage_key": "property/6767906449165602/019cfb3f-8c17-723f-b514-c3e50ea5941a.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJMTLOFjEYsocRbB1wFzphEqI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_5330c8d2-2595-4247-8552-0ef020287085",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "source": "custom",
      "poi_name": "Oklahoma City Zoo",
      "poi_type": "Entertainment",
      "poi_address": "2000 Remington Pl, Oklahoma City, OK 73111, USA",
      "poi_short_description": "Zoo with an array of animals, plus walking trails, shows & attractions such as train tours.",
      "poi_long_description": "Visitors say this zoo offers a wide variety of animals, including elephants, giraffes, stingrays, and a petting zoo, with fun activities like giraffe feeding and a splash pad. They also highlight the friendly and helpful staff, the clean and well-maintained facilities, and the affordable prices, especially with discounts for families and military members.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d7912-7914-7749-a9c3-09d4d6978ef4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-7914-7749-a9c3-09d4d6978ef4",
        "storage_key": "property/6767906449165602/019d7912-7914-7749-a9c3-09d4d6978ef4.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://okczoo.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5013321368135377402&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "oklahoma-city-zoo",
      "poi_latitude": "35.5238895",
      "poi_longitude": "-97.4724932",
      "poi_miles_from_property": "12.2 mi",
      "poi_walking_minutes": "4 hours 31 mins",
      "poi_biking_minutes": "1 hour 12 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 405-424-3344",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019cfb3f-8c1b-71e8-a5bb-506622de100c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-8c1b-71e8-a5bb-506622de100c",
        "storage_key": "property/6767906449165602/019cfb3f-8c1b-71e8-a5bb-506622de100c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJg_EZ4YPguocR-qGV_DjlkkU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "zoo"
    },
    {
      "id": "custom_a2de6054-14ab-43e0-937f-e2d0f34bc873",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "source": "custom",
      "poi_name": "Oklahoma City Museum of Art",
      "poi_type": "Entertainment",
      "poi_address": "415 Couch Dr, Oklahoma City, OK 73102, USA",
      "poi_short_description": "American art from the colonial era to 1960, plus European paintings & contemporary exhibitions.",
      "poi_long_description": "People say this art museum offers stunning glass displays, beautiful artwork, and a great gift shop. They highlight the free admission on the second Sunday of the month and the tranquil, relaxing vibe. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d7912-745d-744f-8524-dad55583fd8f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-745d-744f-8524-dad55583fd8f",
        "storage_key": "property/6767906449165602/019d7912-745d-744f-8524-dad55583fd8f.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "http://www.okcmoa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9657734537123882826&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "oklahoma-city-museum-of-art",
      "poi_latitude": "35.4695638",
      "poi_longitude": "-97.5205029",
      "poi_miles_from_property": "13.3 mi",
      "poi_walking_minutes": "5 hours 3 mins",
      "poi_biking_minutes": "1 hour 23 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 405-236-3100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019cfb3f-8c17-723f-b514-c3e50ea5941a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-8c17-723f-b514-c3e50ea5941a",
        "storage_key": "property/6767906449165602/019cfb3f-8c17-723f-b514-c3e50ea5941a.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ__8_PiwXsocRSmdKhGQqB4Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_museum"
    },
    {
      "id": "custom_f1503bbc-eb88-4e02-87df-d0b7975ef357",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "source": "custom",
      "poi_name": "Oklahoma City National Memorial & Museum",
      "poi_type": "Entertainment",
      "poi_address": "620 N Harvey Ave, Oklahoma City, OK 73102, USA",
      "poi_short_description": "A garden, pool & sculptural memorial commemorating victims of the 1995 Murrah Building bombing.",
      "poi_long_description": "Visitors say this memorial and museum offers a moving experience, honoring the lives lost in the 1995 Oklahoma City bombing. They also highlight the peaceful and serene atmosphere, with many finding it a place for quiet reflection and remembrance.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d7912-78b5-7107-9c33-c1dc38ff3f25.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-78b5-7107-9c33-c1dc38ff3f25",
        "storage_key": "property/6767906449165602/019d7912-78b5-7107-9c33-c1dc38ff3f25.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://memorialmuseum.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4635276338053722639&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "oklahoma-city-national-memorial-museum",
      "poi_latitude": "35.4731496",
      "poi_longitude": "-97.5170593",
      "poi_miles_from_property": "13.3 mi",
      "poi_walking_minutes": "5 hours 1 min",
      "poi_biking_minutes": "1 hour 22 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 405-235-3313",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019cfb3f-8c17-723f-b514-c3e50ea5941a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-8c17-723f-b514-c3e50ea5941a",
        "storage_key": "property/6767906449165602/019cfb3f-8c17-723f-b514-c3e50ea5941a.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJq81FLi4XsocRDzJ3TUXPU0A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_14ac1bd7-4433-445c-a833-1d8ff7d82eec",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "source": "custom",
      "poi_name": "Scissortail Park",
      "poi_type": "Entertainment",
      "poi_address": "300 SW 7th St, Oklahoma City, OK 73109, USA",
      "poi_short_description": "Lively space including gardens, a lake & playground, also home to a farmers' market & concerts.",
      "poi_long_description": "People say this park offers a variety of activities, including walking trails, a splash pad, a playground, and a ninja course. They highlight the beautiful landscaping, flowers, and views, as well as the fun and family-friendly vibe. They also like the free parking and the availability of food trucks and a farmers market.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d7912-7aea-7235-95fb-009ac815e4c0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-7aea-7235-95fb-009ac815e4c0",
        "storage_key": "property/6767906449165602/019d7912-7aea-7235-95fb-009ac815e4c0.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://scissortailpark.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2532545101640635246&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "scissortail-park",
      "poi_latitude": "35.4596348",
      "poi_longitude": "-97.5176865",
      "poi_miles_from_property": "14.2 mi",
      "poi_walking_minutes": "5 hours 21 mins",
      "poi_biking_minutes": "1 hour 27 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 405-445-6277",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019cfb3f-8c22-747e-8c61-88c03495727a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-8c22-747e-8c61-88c03495727a",
        "storage_key": "property/6767906449165602/019cfb3f-8c22-747e-8c61-88c03495727a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5fS8K30XsocRbhPyGFpoJSM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_e0c7dd34-6da0-4437-8912-f68137bc8244",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "source": "custom",
      "poi_name": "Thunder Cleaning Services OKC",
      "poi_type": "Entertainment",
      "poi_address": "6425 Winchester Dr, Oklahoma City, OK 73162, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d7912-8a8a-74b9-9c1f-c723435f2e5d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-8a8a-74b9-9c1f-c723435f2e5d",
        "storage_key": "property/6767906449165602/019d7912-8a8a-74b9-9c1f-c723435f2e5d.webp",
        "width": 1024,
        "height": 684
      },
      "poi_business_url": "http://www.thundercleaningservicesokc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13893539518169662383&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "thunder-cleaning-services-okc",
      "poi_latitude": "35.59359260000001",
      "poi_longitude": "-97.6285998",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 405-972-8473",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019cfb3f-8c1b-71e8-a5bb-506622de100c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-8c1b-71e8-a5bb-506622de100c",
        "storage_key": "property/6767906449165602/019cfb3f-8c1b-71e8-a5bb-506622de100c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJi_0PxM3znIERr8NapZTEz8A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "custom_0c9aebfa-7d74-4642-aa6d-5313ff1b0a72",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "source": "custom",
      "poi_name": "Uptown Grocery",
      "poi_type": "Shopping & Retail",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "uptown-grocery",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [
    {
      "id": "ec_56e632af3949146f2087ea27",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "day": "TUE",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_924825d7357e30d6af3d593c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "day": "FRI",
      "open_time": "08:30",
      "close_time": "17:00"
    },
    {
      "id": "ec_ed1aedeb04d6cf665f4df494",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "15:00"
    },
    {
      "id": "ec_8cac425e4e48dc235599842e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "day": "WED",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_07707319247e14e6d83adf8a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "day": "MON",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_4d7770c93966c9d65ac828d5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "day": "THU",
      "open_time": "08:30",
      "close_time": "17:30"
    }
  ],
  "reviews": [
    {
      "id": "ec_5374afe4f8c7f0f681cfa5dd",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "rating": "5",
      "name": "Haylee Behne",
      "text": "I recently moved here after getting out of a relationship, and I actually love living here. It’s quiet, peaceful, and super close to my workplace. The 1 bed 1 bath is cute, and I was pleasantly surprised to find out my unit has a fireplace. They also let you see the unit before signing, which was so nice! I only wish the floors were hardwood and the appliances/sinks were newer, but otherwise the place is great.\n\nMove-in was quick and easy, and the property manager, Paris, is wonderful. The only thing that sucks is that people aren’t picking up after their dogs and there’s no real incentive to keep it from happening. I also had a couple issues with my heater and my sink filling up when the washer drained, but maintenance handled both quickly and communication was great. I’ve only just moved in but overall I’m excited to live here!",
      "date": "2025-12-03",
      "title": "false"
    },
    {
      "id": "ec_6126409cb2f4cf2dbe81d06d",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "rating": "5",
      "name": "Stephanie Amato",
      "text": "I had a very warm and welcoming experience with leasing consultant, Rosalind. She informed me of all the details about the apartment I asked about and I really loved the idea of being a prospective tenant. I was also informed of the possible job opportunity held as a leasing consultant, as I’m looking for a job such as that, as I’ll be moving into town on the 5th of October. It was very nice of her to accommmodate me of those resources out in the area. She was so helpful! Good luck to Rosalind!",
      "date": "2025-09-28",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_c55f4bce-f32c-4212-a0bc-8e014b23253f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019cfb40-1b54-779e-a21b-d98dedf12e80.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "360 virtual tour of a swimming pool area with lounge chairs and apartment buildings in the background.",
        "public_id": "019cfb40-1b54-779e-a21b-d98dedf12e80",
        "storage_key": "property/6767906449165602/019cfb40-1b54-779e-a21b-d98dedf12e80.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Crown Pointe Virtual Tour",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com/?tour=5f75a13c706a5523cbb261e0&sourceId=1001"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019cf79e-2e3b-76e8-af8d-197e861920d5",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "crown-pointe-apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602"
    },
    {
      "lead_collector_id": "019cf79e-2eb5-7078-a901-87a439e18b86",
      "lead_source": "LANDING_PAGE",
      "name": "crown-pointe-apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "source": "generator",
      "page_item_url": "pool-apartments-in-oklahoma-city-crown-pointe",
      "search_query": "pool apartments Oklahoma City",
      "category": "Amenity",
      "h1_title": "Pool Apartments in Oklahoma City",
      "h2_subtitle": "Discover pool apartments in Oklahoma City at Crown Pointe. Enjoy our sparkling pool, fitness center, and more in the heart of Val Verde.",
      "page_copy": "At Crown Pointe Apartments, experience the luxury of poolside living in Oklahoma City. Our sparkling pool is perfect for relaxing after a long day or hosting a weekend gathering with friends. Situated in the charming Val Verde neighborhood, our community offers modern amenities such as a stylish clubhouse and a state-of-the-art fitness center, ensuring you have everything you need right at home.\n\nChoose from spacious one or two-bedroom floor plans that are designed with your comfort in mind. Each unit features smoke-free living, vaulted ceilings, and walk-up access. Our on-site maintenance team is always ready to assist, and with our convenient package service, you’ll enjoy an easy, stress-free lifestyle. Schedule a tour today to see why Crown Pointe Apartments is the premier choice for pool apartments in Oklahoma City.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019cfb3e-a770-77db-9507-137fb8d431ab.webp",
      "featured_image_media": {
        "alt_text": "Crown Pointe logo",
        "public_id": "019cfb3e-a770-77db-9507-137fb8d431ab",
        "storage_key": "property/6767906449165602/019cfb3e-a770-77db-9507-137fb8d431ab.webp",
        "width": 2550,
        "height": 602
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pool Apartments in Oklahoma City",
      "seo_description": "Explore pool apartments in Oklahoma City! Enjoy the luxury of a sparkling pool and modern amenities at Crown Pointe Apartments. Visit us today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "source": "generator",
      "page_item_url": "fitness-center-apartments-val-verde-crown-pointe",
      "search_query": "apartments with fitness center in Val Verde",
      "category": "Amenity",
      "h1_title": "Apartments with Fitness Center Val Verde",
      "h2_subtitle": "Explore Crown Pointe Apartments with a fitness center in Val Verde. Enjoy modern living with superb amenities just minutes away.",
      "page_copy": "Welcome to Crown Pointe Apartments, where active living meets modern comfort in Val Verde. Our apartments boast a cutting-edge fitness center, enabling residents to maintain a healthy lifestyle without leaving the community. Enjoy the convenience of having a fully-equipped gym just steps from your front door, perfect for cardio and strength training alike.\n\nLocated in the sought-after Val Verde neighborhood, Crown Pointe offers more than just a fitness center. Our residents enjoy a smoke-free environment, vaulted ceilings, and the luxury of a sparkling pool. Choose from thoughtfully designed one or two-bedroom floor plans, each featuring walk-up access and the convenience of on-site maintenance and package services. Embrace a vibrant lifestyle and schedule a tour of our exceptional community today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019cfb3e-a770-77db-9507-137fb8d431ab.webp",
      "featured_image_media": {
        "alt_text": "Crown Pointe logo",
        "public_id": "019cfb3e-a770-77db-9507-137fb8d431ab",
        "storage_key": "property/6767906449165602/019cfb3e-a770-77db-9507-137fb8d431ab.webp",
        "width": 2550,
        "height": 602
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Fitness Center Val Verde",
      "seo_description": "Live actively at Crown Pointe in Val Verde. Enjoy our on-site fitness center, modern amenities, and comfortable one or two-bedroom apartments!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "source": "generator",
      "page_item_url": "dishwasher-equipped-apartments-okc-crown-pointe",
      "search_query": "dishwasher equipped apartments OKC",
      "category": "Amenity",
      "h1_title": "Dishwasher Equipped Apartments in OKC",
      "h2_subtitle": "Discover dishwasher equipped apartments at Crown Pointe in OKC. Embrace a lifestyle of convenience and modern amenities in Val Verde.",
      "page_copy": "Crown Pointe Apartments in Oklahoma City offer the perfect blend of comfort and efficiency with dishwasher equipped units. Nestled in the scenic Val Verde neighborhood, our one and two-bedroom floor plans are designed with your convenience in mind. Imagine returning home to a modern kitchen where cleaning up is a breeze, allowing you more time to unwind or entertain.\n\nBeyond the advantage of dishwasher equipped apartments, Crown Pointe provides a host of amenities to enhance your lifestyle. Whether it's enjoying a dip in our sparkling pool, maintaining your fitness routine at our gym, or relaxing in the stylish clubhouse, there's something for everyone. Plus, with package service and on-site maintenance, you'll experience hassle-free living. Visit us in OKC today to see how Crown Pointe Apartments redefine modern living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019cfb3e-a770-77db-9507-137fb8d431ab.webp",
      "featured_image_media": {
        "alt_text": "Crown Pointe logo",
        "public_id": "019cfb3e-a770-77db-9507-137fb8d431ab",
        "storage_key": "property/6767906449165602/019cfb3e-a770-77db-9507-137fb8d431ab.webp",
        "width": 2550,
        "height": 602
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dishwasher Equipped Apartments in OKC",
      "seo_description": "Find dishwasher equipped apartments in OKC at Crown Pointe! Enjoy modern amenities and convenient living in the Val Verde neighborhood.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "source": "generator",
      "page_item_url": "clubhouse-apartments-near-73142-crown-pointe",
      "search_query": "clubhouse apartments near 73142",
      "category": "Amenity",
      "h1_title": "Clubhouse Apartments Near 73142",
      "h2_subtitle": "Explore clubhouse apartments near 73142 at Crown Pointe. Enjoy vibrant community living with impressive amenities in Oklahoma City.",
      "page_copy": "Crown Pointe Apartments is your destination for extraordinary apartment living near 73142. Our community offers an elegant and inviting clubhouse, perfect for social gatherings, community events, or simply unwinding after a long day. Located in the heart of Oklahoma City, Crown Pointe epitomizes modern living with a range of amenities to cater to your lifestyle.\n\nIn addition to our stylish clubhouse, Crown Pointe Apartments boasts a sparkling pool, state-of-the-art fitness center, and smoke-free living in spacious one and two-bedroom units. Enjoy vaulted ceilings and walk-up access, complemented by the convenience of on-site maintenance and package services. Whether you're hosting friends or relaxing alone, our apartments provide the ideal setting. Schedule a tour today and see why our clubhouse apartments near 73142 are the perfect choice for you!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019cfb3e-a770-77db-9507-137fb8d431ab.webp",
      "featured_image_media": {
        "alt_text": "Crown Pointe logo",
        "public_id": "019cfb3e-a770-77db-9507-137fb8d431ab",
        "storage_key": "property/6767906449165602/019cfb3e-a770-77db-9507-137fb8d431ab.webp",
        "width": 2550,
        "height": 602
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Clubhouse Apartments Near 73142",
      "seo_description": "Find clubhouse apartments near 73142 at Crown Pointe. Experience community living with modern amenities in a premier Oklahoma City location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "source": "generator",
      "page_item_url": "air-conditioned-apartments-oklahoma-city-crown-pointe",
      "search_query": "air conditioned apartments in Oklahoma City",
      "category": "Amenity",
      "h1_title": "Air Conditioned Apartments Oklahoma City",
      "h2_subtitle": "Stay cool at Crown Pointe Apartments in Oklahoma City. Our air-conditioned homes offer comfort and great amenities in Val Verde.",
      "page_copy": "Experience year-round comfort at Crown Pointe Apartments in Oklahoma City, where every unit comes equipped with efficient air conditioning. Located in the serene Val Verde neighborhood, our community offers the ultimate in modern living, with amenities designed for your comfort and convenience. Whether you're enjoying a quiet evening at home or hosting friends, our air-conditioned apartments provide a refreshing haven.\n\nCrown Pointe goes beyond air conditioning with an array of features to enrich your living experience. From our sparkling pool and fitness center to the stylish clubhouse, there's much to explore and enjoy. Our spacious one and two-bedroom floor plans include vaulted ceilings and walk-up access. With on-site maintenance and package service, you'll love the hassle-free lifestyle. Visit us today and discover why our Oklahoma City community is the ideal place to call home!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019cfb3e-a770-77db-9507-137fb8d431ab.webp",
      "featured_image_media": {
        "alt_text": "Crown Pointe logo",
        "public_id": "019cfb3e-a770-77db-9507-137fb8d431ab",
        "storage_key": "property/6767906449165602/019cfb3e-a770-77db-9507-137fb8d431ab.webp",
        "width": 2550,
        "height": 602
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air Conditioned Apartments Oklahoma City",
      "seo_description": "Live comfortably in air conditioned apartments at Crown Pointe, Oklahoma City. Enjoy modern amenities and a vibrant community in Val Verde.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-val-verde-ok-crown-pointe",
      "search_query": "one bedroom apartments val verde ok",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Val Verde, OK",
      "h2_subtitle": "Discover spacious one bedroom apartments in Val Verde, OK, at Crown Pointe. Experience comfort and style in Oklahoma City's vibrant community.",
      "page_copy": "Crown Pointe Apartments invites you to explore our one bedroom apartments located in the desirable Val Verde neighborhood of Oklahoma City. Perfectly sized and thoughtfully designed, our one-bedroom homes offer the ideal blend of comfort and style. With modern amenities and spacious layouts, you'll find everything you need to create a cozy, welcoming environment.\n\nBeyond the beautifully designed one bedroom apartments, residents at Crown Pointe enjoy access to premium amenities, including a sparkling pool, fitness center, and a clubhouse perfect for entertaining or relaxing. Our community offers the convenience of on-site maintenance, package services, and smoke-free living. Come and find your new home in Val Verde, OK, where comfort meets convenience at Crown Pointe Apartments.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019cfb3e-a770-77db-9507-137fb8d431ab.webp",
      "featured_image_media": {
        "alt_text": "Crown Pointe logo",
        "public_id": "019cfb3e-a770-77db-9507-137fb8d431ab",
        "storage_key": "property/6767906449165602/019cfb3e-a770-77db-9507-137fb8d431ab.webp",
        "width": 2550,
        "height": 602
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Val Verde, OK",
      "seo_description": "Explore one bedroom apartments in Val Verde, OK, at Crown Pointe. Enjoy comfort and amenities in Oklahoma City's premier community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165602",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-okc-73142-crown-pointe",
      "search_query": "two bedroom apartments okc 73142",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in OKC 73142",
      "h2_subtitle": "Find spacious two bedroom apartments in the 73142 area at Crown Pointe. Experience premium living with modern amenities in Oklahoma City.",
      "page_copy": "Discover the spacious and versatile two bedroom apartments at Crown Pointe, nestled in the vibrant 73142 zip code of Oklahoma City. Our community offers the perfect setting for those seeking a balance of comfort and modern living. Each two-bedroom unit is designed with ample space, ideal for roommates, families, or anyone in need of a little extra room.\n\nCrown Pointe Apartments boasts a range of amenities beyond our spacious two bedroom homes. Residents can enjoy a sparkling pool, a state-of-the-art fitness center, and a stylish clubhouse—perfect for entertaining guests or meeting neighbors. With the added convenience of on-site maintenance and smoke-free living, Crown Pointe is more than just a place to live—it's a community you'll love. Visit us and see why our two bedroom apartments in OKC 73142 are the right choice for your next home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019cfb3e-a770-77db-9507-137fb8d431ab.webp",
      "featured_image_media": {
        "alt_text": "Crown Pointe logo",
        "public_id": "019cfb3e-a770-77db-9507-137fb8d431ab",
        "storage_key": "property/6767906449165602/019cfb3e-a770-77db-9507-137fb8d431ab.webp",
        "width": 2550,
        "height": 602
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in OKC 73142",
      "seo_description": "Discover two bedroom apartments in OKC 73142 at Crown Pointe. Enjoy modern amenities and spacious living in Oklahoma City.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5171"
    },
    {
      "ID": "custom_ga4_id",
      "type": "STRING",
      "value": "G-KJPECYT0HF"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "10041151589"
    },
    {
      "ID": "custom_tour24_url",
      "type": "STRING",
      "value": "https://app.tour24now.com/prospect/tour/crown-pointe/register/"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-N4ZKT6V7"
    },
    {
      "ID": "custom_floorplan_pdf_url",
      "type": "STRING",
      "value": "https://multihubmedia.com/property/6767906449165602/019d1bd8-0386-7654-9fd8-fcde97c380c0.pdf"
    },
    {
      "ID": "custom_rentgrata_property_id",
      "type": "STRING",
      "value": "b1f709a2-1eba-4a67-9cde-513e350cf1da"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "800-647-9322"
    },
    {
      "ID": "custom_residentboost_apartment_id",
      "type": "STRING",
      "value": "64ac4edf8bf14accd1324efd"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IlhBMm9VSm1ScHlOTGlwQzFRdzVHOHc9PSIsInZhbHVlIjoiNi9wQ1dKUDcrV21INURUUUtRcHEvUT09IiwibWFjIjoiZDYwZGFhNThhMmFmZDExNTUxYmI1OGFkNmZmOTRlZWE0YTNkOTk1Mjg5MjMxYTY0Yzk0ZDAxNDc4NmRiZTQ2MCJ9"
    }
  ],
  "custom_qb_id": "5171",
  "custom_ga4_id": "G-KJPECYT0HF",
  "custom_repli_id": "10041151589",
  "custom_tour24_url": "https://app.tour24now.com/prospect/tour/crown-pointe/register/",
  "custom_google_gtm_id": "GTM-N4ZKT6V7",
  "custom_floorplan_pdf_url": "https://multihubmedia.com/property/6767906449165602/019d1bd8-0386-7654-9fd8-fcde97c380c0.pdf",
  "custom_rentgrata_property_id": "b1f709a2-1eba-4a67-9cde-513e350cf1da",
  "custom_ppc_tracking_phone_number": "800-647-9322",
  "custom_residentboost_apartment_id": "64ac4edf8bf14accd1324efd",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IlhBMm9VSm1ScHlOTGlwQzFRdzVHOHc9PSIsInZhbHVlIjoiNi9wQ1dKUDcrV21INURUUUtRcHEvUT09IiwibWFjIjoiZDYwZGFhNThhMmFmZDExNTUxYmI1OGFkNmZmOTRlZWE0YTNkOTk1Mjg5MjMxYTY0Yzk0ZDAxNDc4NmRiZTQ2MCJ9"
};

export const generatedAt = '2026-08-27T21:38:22.892Z';
